export const SK = {
  preparing_zip: "Príprava zipu…",
  compressing: "Komprimácia…",
  info_icon: "Po označení ako dokončené sa nemôžu pridať ani pripojiť ďalší členovia a všetky chatové skupiny budú deaktivované. Upozorňujeme, že projekt spolu so všetkými chatovými skupinami a údajmi zostane prístupný v deaktivovanom stave.",
  mark_is_done: "Naozaj chcete označiť projekt ako dokončený? Po označení sa nemôžu pridať ani pripojiť ďalší členovia a všetky chatové skupiny budú deaktivované. Upozorňujeme, že projekt spolu so všetkými chatovými skupinami a údajmi zostane prístupný v deaktivovanom stave.",
  mark_not_done: "Naozaj chcete projekt znova otvoriť? Po označení ako otvorený sa môžu pridať alebo pripojiť ďalší členovia a všetky chatové skupiny budú znova aktivované.",
  mark_as_completed: "Označiť projekt ako dokončený",
  room_completed: "Projekt dokončený",
  room_members: "Členovia projektu",
  deactivated_rooms: "Deaktivované projekty",
  deactivated_chats: "Deaktivované chaty",
  completed_rooms: "Dokončené projekty",
  request_to_join_a_room: 'Žiadosť o pripojenie do projektu',
  wants_to_rejoin_room: 'Používateľ sa chce znova pripojiť do projektu Roomname.',
  invited_you_to_join_room: 'Používateľ vás pozval do projektu Roomname.',
  restart: "Reštartovať",
  update_text: "K dispozícii je nová aktualizácia. Kliknutím na Reštartovať nainštalujte aktualizáciu.",
  update_availble: "Aktualizácia je k dispozícii",
  Loading: "Načítava sa...",
  logout: "Odhlásiť sa",
  back: 'Späť',
  company_list: "Zoznam spoločností",
  followers: "Sledovatelia",
  followings: "Sledované",
  article: "Článok",
  companies: "Spoločnosti",
  one_to_one_chat: " Chat jeden na jedného",
  profile: "Profil",
  company: "Spoločnosť",
  company_selection: "Výber spoločnosti",
  home: "Domov",
  contact: "Kontakt ",
  add_company: "Pridať spoločnosť ",
  add_project: "Pridať projekt ",
  capacities: "Kapacity ",
  work_area: "Pracovná oblasť",
  company_services: "Služby spoločnosti",
  website: "Webová stránka",
  search_contacts: "Hľadať kontakty",
  add_or_join_a_company: "Pridať alebo pripojiť sa k spoločnosti",
  follow: "Sledovať",
  following: "Sledované",
  like: "Páči sa mi",
  company_contacts: "Kontakt spoločnosti",
  leave_the_company: "Opustiť spoločnosť",
  news: "Novinky",
  earlier: "Skôr",
  action: "Akcia",
  another_action: "Ďalšia akcia",
  something_else: "Niečo iné",
  search: "Hľadať",
  search_rooms: "Hľadať projekty",
  search_articles: "Hľadať články",
  contacts: "Kontakty",
  suggestions: "Návrhy",
  project_list: "Zoznam projektov",
  search_results: "Výsledky vyhľadávania",
  add_or_join_project: "Pridať alebo pripojiť sa do projektu",
  details: "Podrobnosti",
  your_position_within_company:
    "Vyberte si svoju pozíciu v rámci spoločnosti.",
  close_modal: "Zavrieť",
  map: "Mapa",
  or: "Alebo",
  name: "Meno*",
  street: "Ulica*",
  house_number: "Číslo domu",
  postal_code: "PSČ",
  city: "Mesto*",
  opened_by: "Otvoril:",
  project_No: "Č. projektu: ",
  building_type: "Typ budovy*",
  building_types: "Typ budovy",
  add_join: "Pridať/Pripojiť",
  mandatory_fiels: "*povinné polia",
  invalid_fiels: "Toto pole je povinné",
  add_or_join_company: "Pridať alebo pripojiť sa k spoločnosti",
  name_of_the_company: "Názov spoločnosti",
  edit_company_details: "Upraviť údaje spoločnosti",
  branch_of_the_building_industry: "Odvetvie stavebného priemyslu",
  corporate_form: "Právna forma",
  position_within_company: "Pozícia v rámci spoločnosti",
  request_confirmation: "Čakajúce žiadosti o projekt",
  company_e_mail: "E-mail spoločnosti",
  type_of_filter: "Píšte pre filtrovanie...",
  setting: "Nastavenie",
  dashboard: "Prehľad",
  settings: "Nastavenia",
  views: "Zobrazenia",
  times_seen: "krát videné",
  see_more: "...viac",
  see_less: "...menej",
  in_search: "vo vyhľadávaní",
  reset_password: "Obnoviť heslo",
  submit: "Odoslať",
  password: "Heslo",
  email: "E-mail",
  confirm_password: "Potvrdiť heslo",
  reset_email: "Obnoviť e-mail",
  update: "Aktualizovať",
  new_email: "Nový e-mail",
  kjuup_message: "Správa Kjuup",
  delete_profile: "Odstrániť profil?",
  my_position: "Moja pozícia:",
  add: "pridať",
  owner_company_admin: "Správca spoločnosti :",
  owner_company_admin_new: "Správca spoločnosti",
  mutual_contact: "spoločný kontakt",
  mutual_contacts: "spoločné kontakty",
  co_owner: "Spolumajiteľ",
  managing_director: "Konateľ",
  associate: "Spoločník",
  secretary: "Sekretár/ka",
  employee: "Zamestnanec",
  project_manage: "Projektový manažér",
  auto_chat_translation: "Automatický preklad chatu",
  translate_room_group_names: "Prekladať názvy skupinových chatov",
  translate_room_group_names_info: "Ak je zapnuté, názvy skupinových chatov sa automaticky prekladajú do jazyka rozhrania.",
  default_view_email: "Predvolené zobrazenie: E-mail",
  default_view_email_info: "Keď je zapnuté, pri otvorení aplikácie sa namiesto Správ predvolene otvorí karta E-mail.",
  integrate_email_in_messages: "Kombinovať e-mail a správy",
  integrate_email_in_messages_info: "Keď je zapnuté, e-maily zo všetkých pripojených účtov sa zobrazia spolu s vašimi chatovými správami, zoradené podľa dátumu.",
  language: "Jazyk",
  english: "Angličtina",
  german: "Nemčina",
  french: "Francúzština",
  italian: "Taliančina",
  change_language: "Zmeniť jazyk",
  my_companies: "Moje spoločnosti",
  employees: "Zamestnanci",
  invite_with_a: "Pozvať do Kjuup",
  add_member: "Pridať člena",
  add_user: "Pridať používateľa",
  send_location: "Odoslať polohu",
  assign_admin_rights: "Upraviť práva správcu",
  deactivate_company: "Deaktivovať spoločnosť",
  remove_employees: "Odstrániť zamestnancov",
  remove_members: "Odstrániť členov",
  no_user_found: "Nenašiel sa žiadny používateľ!",
  approve: "Schváliť!",
  deselect_all: "Zrušiť výber všetkých",
  select_all: "Vybrať všetky",
  translation_on_building_projects: "Preklad v projektoch",
  reported_capacities: "Nahlásené služby",
  up_to_50m_exact: "Presne do 50 m",
  company_details_service: "Služby spoločnosti",
  company_contact: "Kontakt spoločnosti",
  invite_with_link: "Pozvať do Kjuup",
  share_link: "Zdieľať odkaz",
  share_company_link: "Zdieľať odkaz",
  qr_code: "QR kód",
  copy_link: "Kopírovať odkaz",
  cancel_link: "Zrušiť odkaz",
  who_has_confirmed_services: "Kto potvrdil vaše služby?",
  projectss: "Projekty",
  add_services: "Pridať služby",
  services: "Služby",
  save_text: "Uložiť",
  share_on: "Zdieľať na:",
  articlen: "Článok",
  invite_user_to_confirm_service:
    "Pozvite používateľov, aby potvrdili služby spoločnosti.",
  link_copied: "Odkaz skopírovaný!",
  email_copied: "E-mail skopírovaný!",
  personal_article: "Osobný článok",
  company_article: "Článok spoločnosti",
  characters_remaining: "Zostávajúce znaky",
  optional_information: "Voliteľné informácie",
  project: "Projekt",
  projects: "Projekty...",
  abort: "Zahodiť",
  preview: "Náhľad",
  post: "Uverejniť",
  of: "z",
  remove: "Odstrániť",
  free_capacity: "Pracovný portál",
  current_status_overview: "Prehľad aktuálneho stavu",
  report_capacities: "Nahlásiť služby",
  report_text: "Nahlásiť",
  search_capacities: "Nájsť dodávateľov",
  add_project_user: "Pridať používateľa projektu",
  media: "Médiá",
  links: "Odkazy",
  docs: "Dokumenty",
  featured_products: "Odporúčané produkty...",
  title: "Názov",
  text: "Text",
  feed_details: "Podrobnosti príspevku",
  add_employee: "Pridať zamestnanca",
  latest: "Najnovšie",
  my_projects: "Moje projekty",
  cancel: "Zrušiť",
  continue: "Pokračovať",
  role_in_the_building_industry: "Rola v stavebnom priemysle",
  als: "ako",
  join: "pripojiť sa",
  find: "Nájsť",
  request_to_join_a_company: "Žiadosť o pripojenie k spoločnosti",
  wants_to_join_the_company: "sa chce pripojiť k spoločnosti",
  filter_by: "Filtrovať podľa",
  ok: "Ok",
  close: "Zavrieť",
  weekly_statistics: "Týždenné štatistiky",
  is_following_you: "vás sleduje.",
  as: "ako",
  has_joined_the: "sa pripojil k spoločnosti",
  has_looked_at_your_profile: "si pozrel váš profil.",
  time: "krát",
  in_searches_in_past_week: "vo vyhľadávaniach za posledný týždeň.",
  has_liked_your_article: "označil váš článok ako Páči sa mi.",
  has_published_a_new_article: "uverejnil nový článok.",
  you: "Vy",
  all_views: "Všetky zobrazenia",
  all_profile_views: "Všetky zobrazenia profilu",
  mutual_company: "spoločná spoločnosť",
  artical_text: "Napíšte článok...",
  you_have_appeared: "Objavili ste sa",
  your_request_at_the_company: "Vaša žiadosť v spoločnosti",
  times_you_have_appeared_in_searches: "krát ste sa objavili vo vyhľadávaniach",
  appear_more_often_in_searches: "Objavovať sa častejšie vo vyhľadávaniach",
  you_have_been_found: "Boli ste nájdený",
  improve_profile: "Vylepšiť profil",
  choose_existing_contact_for_single_chat:
    "Vyberte existujúci kontakt pre individuálny chat:",
  in_order_to_add_new_contacts:
    "Ak chcete pridať nové kontakty, vyhľadajte nové kontakty na stránke profilu.",
  times_in_searches_in_the_last_week:
    "krát vo vyhľadávaniach za posledný týždeň. Aktualizujte svoj profil a pridajte ďalšie podrobnosti, aby vás bolo možné ľahšie nájsť.",
  has_been_confirmed: "bolo potvrdené.",
  have_joined_the: "sa pripojili k  ",
  building_project: " stavebnému projektu.",
  select_with_which_company_you_want_to_connect_to_the_project:
    "Vyberte spoločnosť, ktorú budete zastupovať. Toto sa zobrazí ostatným účastníkom.",
  select_with_which_company_you_want_to_connect_to_the_chat:
    "Vyberte spoločnosť, ktorú budete zastupovať. Toto sa zobrazí ostatným účastníkom.",
  select_internal_section: "Vyberte internú sekciu",
  select_profile_image: "Vyberte profilový obrázok",
  share_user: "Zdieľať používateľa",
  contact_sender_message:
    "Zdieľajte tento odkaz a pozvite nečlena Kjuup do Kjuup. Tento odkaz môže použiť viacero osôb na registráciu.",
  project_sender_message:
    "Zdieľajte tento odkaz a pozvite nečlena Kjuup do projektu project name. Tento odkaz môže použiť viacero osôb na registráciu a pripojenie do projektu project name v Kjuup.",
  company_sender_message:
    "Zdieľajte tento odkaz a pozvite nečlena Kjuup do spoločnosti company name. Tento odkaz môže použiť viacero osôb na registráciu a pripojenie k spoločnosti v Kjuup.",
  contact_receivers_message:
    "Pozývací odkaz na pripojenie do Kjuup. Kliknutím na odkaz sa zaregistrujete do Kjuup.",
  iphone: "iPhone:",
  iphone_recivers_message:
    "Ak inštalujete Kjuup cez Apple App Store, po úspešnom stiahnutí musíte kliknúť na tento odkaz, aby ste sa mohli zaregistrovať.",
  project_receivers_message:
    "Pozývací odkaz na pripojenie do projektu project name v Kjuup. Kliknutím na odkaz sa zaregistrujete do Kjuup a pripojíte do projektu project name.",
  company_receivers_message:
    "Pozývací odkaz do spoločnosti company name v Kjuup. Kliknutím na odkaz sa zaregistrujete do Kjuup a pripojíte k spoločnosti company name.",
  sign_in: "Prihlásiť sa",
  enter_your_email_add: "Zadajte svoju e-mailovú adresu",
  forgot_password: "Zabudli ste heslo",
  dont_have_account: "Nemáte účet?",
  register: "Registrovať sa",
  get_app: "Získať aplikáciu",
  registration: "Registrácia",
  dep_ing: "Dipl.-Ing.",
  dr: "Dr.",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. architekt",
  prof: "Prof.",
  first_name: "Meno",
  last_name: "Priezvisko",
  have_an_account: "Máte účet?",
  when_register_you_agree: "Registráciou súhlasíte s našimi",
  term_of_use: "podmienkami používania",
  to: "na.",
  in_our: "V našich",
  data_policy: "zásadách ochrany údajov",
  they_find_out: "sa dozviete,",
  we_provide_store_data: "ako zhromažďujeme, spracúvame a uchovávame informácie.",
  leaving_company_text:
    "Naozaj chcete opustiť spoločnosť? Pri opustení spoločnosti opustíte aj všetky súvisiace projekty a chatové skupiny. Do týchto projektov sa môžete kedykoľvek znova pripojiť s inou spoločnosťou.",
  delete_profile_text:
    "Naozaj chcete odstrániť svoj profil? Pri odstránení profilu sa odstránia všetky prepojenia so spoločnosťami, projektmi a chatmi. Nový profil si môžete kedykoľvek vytvoriť.",
  confirm: "Potvrdiť",
  reject: "Odmietnuť",
  requet_to_leave: "Žiadosť o opustenie",
  choose: "Vybrať",
  your_add_member: "Pridať člena",
  if_you: "v prípade, že",
  can_not_find: "tu nemôžete nájsť svoj kontakt.",
  please_wait: "Čakajte prosím..",
  imprint_gtc: "Tiráž/VOP",
  register_confirm_popup: "Pred prihlásením overte svoju e-mailovú adresu Kjuup. Odoslali sme potvrdzovací odkaz. Ak ho nevidíte, skontrolujte aj priečinok spam.",
  PENDING_GROUP_USER:
    "bude dostávať správy až po potvrdení pozvania do projektu. Po potvrdení pozvania do projektu sa zobrazí ďalšia správa.",
  PENDING: "Čaká sa na potvrdenie pozvania do projektu",
  denied_group_chat: " odmietol pozvanie do projektu a opustil túto skupinu.",
  // joined_group_chat: " has joined the room and this group.",
  joined_group_chat: " sa pripojil k tejto skupine",
  you_joined_group_chat: "Pripojili ste sa k tejto skupine.",
  Others: "Ostatní",
  LEFT_GROUP: "opustil túto chatovú skupinu.",
  YOU_LEFT_GROUP: "opustili ste túto chatovú skupinu.",
  days: "dni",
  day: "deň",
  hour: "hodina",
  hide_project: "Skryť projekt",
  hide_project_popup_text:
    "Ak skryjete projekty, nebude ich možné nájsť v Kjuup. Nových používateľov do projektu môžu pozvať iba členovia projektu.",
  branch: "Odvetvie",
  photo_video_media_lib: "Knižnica fotografií a videí",
  document: "Dokument",
  location: "Poloha",
  location_meeting: "Poloha / Stretnutie",
  all_member_of_project: "Všetci členovia projektu",
  pending_request: "Čakajúce žiadosti o projekt",
  no_pending_request: "Nenašli sa žiadne čakajúce žiadosti!",
  news_feed: "Nástenka noviniek",
  user_info: "Informácie o skupine",
  leave_project: "Opustiť projekt",
  media_link_docs: "Súbory",
  search_chat: "Hľadať v chate",
  export_chat_group: "Exportovať údaje chatovej skupiny za posledný mesiac",
  request_complete_chat_history: "Vyžiadať kompletnú históriu chatu",
  leave_chat_group: "Opustiť chatovú skupinu",
  add_user_project: "Pridať používateľa",
  me: "Ja",
  max_open_one_to_one:
    "Momentálne je možné súčasne otvoriť max. 2 individuálne chaty v spodnej a hornej sekcii. Celkovo je možných max. 4 individuálnych chatov.",
  are_you_sure_you_want_leave_chat:
    "Naozaj chcete opustiť túto chatovú skupinu?",
  create_group: "Vytvoriť skupinu",
  adding_members: "Pridávanie členov...",
  creating_the_chat: "Vytváranie chatu...",
  finishing_setup: "Dokončovanie nastavenia...",
  group_name: "Názov skupiny",
  by: "Od:",
  mandetory: "*povinné",
  delteed: "odstránil svoj profil a opustil skupinový chat.",
  deleted_direct: "odstránil svoj profil a opustil chat.",
  unhidden_message:
    "Ak zrušíte skrytie projektov, budú ich môcť nájsť všetci členovia Kjuup.",
  account_deleted: "Účet bol odstránený.",
  refuse_company: "Naozaj chcete odmietnuť pozvanie do spoločnosti?",
  follow_additional: "Sledovať ďalších používateľov",
  f_add:
    "Sledujte ďalších používateľov Kjuup, aby ste im mohli posielať priame správy.",
  c_inv: "Pozvanie(a) do spoločnosti",
  invited_o_Company: "Boli ste pozvaní pripojiť sa k spoločnosti",
  refuse_companyX: "Naozaj chcete odmietnuť žiadosť spoločnosti?",
  a_Da: "Účet deaktivovaný.",
  has_deactivated: "deaktivoval svoj profil.",
  reactive: "znova aktivoval svoj profil.",
  juup_note: "*Registrácia iba používateľským menom je dostupná len pre členov Kjuup+",
  username: "Používateľské meno*",
  email_username: "E-mail/Používateľské meno*",
  sPinText:
    "Zadajte 6-miestny bezpečnostný PIN. Tento PIN bude potrebný v prípade, že zabudnete heslo, a je povinný na potvrdenie vášho účtu.",
  DeleteKjuupPlusText:
    "Naozaj chcete odstrániť svoj profil? Pri odstránení profilu sa odstránia všetky prepojenia so spoločnosťami, projektmi a chatmi.\n\nDo 48 hodín po odstránení účtu môžete svoj účet znova aktivovať prihlásením sa používateľským menom, heslom a PIN-om.",
  reactive_text:
    "Váš účet bol odstránený. Kliknutím na Znova aktivovať obnovíte svoj účet.",
  rac: "Znova aktivovať",
  ac_ss: "Účet bol úspešne znova aktivovaný.",
  not_valid_pin: "Neplatný PIN",
  only_for_kjuup:
    "*Obnovenie hesla pomocou používateľského mena a PIN-u je dostupné len pre členov Kjuup+.",
  resetPIN: "Obnoviť PIN",
  enter_current_pin: "Zadajte svoj aktuálny PIN",
  enter_new: "Zadajte nový PIN",
  pin_to_confirm: "Zadajte PIN na potvrdenie.",
  change_username: "Obnoviť používateľské meno",
  pp_not_match: "Heslo a potvrdenie hesla sa nezhodujú",
  reactive_itself: "Znova ste aktivovali svoj profil.",
  has_deactivated_itself: "Deaktivovali ste svoj profil.",
  more_than_two:
    "Momentálne je možné posielať priame správy súčasne iba s 2 používateľmi.",
  Chats: "Priame správy",
  only_in_mobileL:
    "Natívne videá je momentálne možné nahrávať a uverejňovať iba cez mobilnú aplikáciu. Použite prosím odkazy na videá z YouTube a Vimeo.",
  register_pin_text:
    "Vyberte si svoj osobný 6-miestny PIN. Tento PIN bude potrebný na povolenie funkcií obnovenia účtu.",
  internal_project: "Interné",
  external_projects: "Externé",
  in_deacticted: "Interná sekcia je deaktivovaná.",
  create_article: "Vytvoriť článok",
  new_article_selection: "Vytvoriť článok pre externú nástenku noviniek",
  new_article_selection_internal: "Vytvoriť interný článok",
  active_trans_title: "Zapnúť automatický preklad?",
  active_trans:
    "Keď je zapnuté, všetky prichádzajúce chatové správy budú preložené do vášho vybraného jazyka aplikácie.",
  disable_trans: "Naozaj chcete deaktivovať automatický preklad?",
  allow_access_chat: "Zobraziť celú históriu chatu",
  toggle_chat_history_on:
    "Naozaj chcete, aby používateľ videl celú históriu chatu?",
  toggle_chat_history_off:
    "Naozaj chcete, aby používateľ videl históriu chatu iba od momentu pripojenia do chatu?",
  check_selected_settings:
    "Skontrolujte nastavenia histórie chatu pre všetkých vybraných používateľov!",
  chat_from_start_have:
    "Pripojili ste sa k tejto skupine. História chatu bola zdieľaná.",
  chat_from_start_has:
    "sa pripojil k tejto skupine. História chatu bola zdieľaná.",
  Address: "Adresa",
  read_by: "Prečítané používateľom",
  deliver_to: "Doručené používateľovi",
  remaining: "zostáva",
  message_info: "Informácie o správe",
  request_to_join_only: "Žiadosť o pripojenie",
  unfollow: "Prestať sledovať",
  company_username: "Používateľské meno",
  month: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Máj",
    "Jún",
    "Júl",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dec",
  ],
  remove_my_admin_right: "Odstrániť moje práva správcu",
  makeEmp: "Naozaj chcete používateľovi odobrať práva správcu spoločnosti?",
  remove_my_self:
    "Naozaj chcete odobrať práva správcu spoločnosti zo svojho účtu?",
  makeAdmin: "Naozaj chcete používateľovi udeliť práva správcu spoločnosti?",
  remove_member: "Odstrániť člena",
  remove_following_confirm: "Naozaj chcete odstrániť {name}?",
  remove_follower_confirm: "Naozaj chcete odstrániť {name} zo sledovateľov? Ak ho/ju odstránite, nebude o tom informovaný/á.",
  do_you_really_want_to_remove:
    "Naozaj chcete odstrániť používateľa username zo spoločnosti?",
  invite_all: "Pozvať všetkých členov spoločnosti",
  invite_all_members: "Pozvať všetkých členov",
  mems: "Všetci ostatní členovia",
  dep_loc: "Oddelenie/Lokalita/Tím",
  depAdmin: "Správca oddelenia",
  add_remove_admin: "Pridať/Odstrániť pozíciu správcu spoločnosti",
  add_remove_dep_admin: "Pridať/Odstrániť pozíciu správcu oddelenia",
  remove_employees_dept: "Odstrániť zamestnancov z",
  want_to_join_dep:
    "Username sa chce pripojiť k oddeleniu/lokalite/tímu depname spoločnosti companyname.",
  you_invited:
    "Boli ste pozvaní pripojiť sa k oddeleniu/lokalite/tímu depname spoločnosti companyname.",
  dep_remove:
    "Naozaj chcete používateľovi odobrať práva správcu oddelenia alebo lokality?",
  add_dep:
    "Naozaj chcete používateľovi udeliť práva správcu oddelenia alebo lokality?",
  my_self_dep_remove:
    "Naozaj chcete odobrať práva správcu oddelenia zo svojho účtu?",
  member: "Člen",
  admin: "Správca",
  remove_project_admin:
    "Naozaj chcete odstrániť člena z projektu?",
  remove_my_self_project: "Naozaj chcete odobrať práva správcu?",
  remove_member_admin_right:
    "Naozaj chcete používateľovi odobrať práva správcu?",
  add_member_admin_right: "Naozaj chcete používateľovi pridať práva správcu?",
  add_remove_Poss: "Pridať/Odstrániť pozíciu správcu",
  forward: "Preposlať",
  forward_to: "Preposlať do...",
  edit: "Upraviť",
  only_kjuup_plus_can: "Iba spoločnosti Kjuup+ môžu uverejňovať články.",
  add_images: "Pridať obrázok(y)",
  add_images_or_pdf: "Pridať obrázky, videá alebo PDF",
  drop_files_here: "Sem presuňte súbory",
  drag_and_drop_hint_pdf: "alebo sem presuňte obrázky, videá či PDF",
  unsupported_file_type: "Nepodporovaný typ súboru. Povolené sú iba obrázky, videá a PDF.",
  max_file_size_exceeded_25mb: "Maximálna veľkosť 25 MB bola prekročená. Vyberte menší súbor.",
  request_confirmation: 'Čakajúce pozvania do projektu',
  Activity: "Aktivita",
  latest_messages: "Najnovšie správy",
  hours: "hodiny",
  minute: "minúty",
  seconds: "sekundy",
  days: "dni",
  yesterday: "včera",
  last_week: "Minulý týždeň",
  this_week: "Tento týždeň",
  next_week: "budúci týždeň",
  Last_month: "Minulý mesiac",
  this_month: "Tento mesiac",
  All: "Všetko",
  register_plus: "Registrácia Plus",
  select_files: "Vybrať súbory",
  monthsFullName: [
    "Január",
    "Február",
    "Marec",
    "Apríl",
    "Máj",
    "Jún",
    "Júl",
    "August",
    "September",
    "Október",
    "November",
    "December",
  ],
  company_deploc_receivers_message:
    "Pozývací odkaz do oddelenia spoločnosti company name v Kjuup. Kliknutím na odkaz sa zaregistrujete do Kjuup a pripojíte k spoločnosti company name.",
  no_news: "Žiadne novinky nie sú k dispozícii",
  reminder: "Pripomienka",
  np_reminder: "Žiadne úlohy",
  move_to_reminder: "Presunúť do úloh",
  remove_reminder: "Naozaj chcete odstrániť túto správu zo zoznamu vašich úloh?",
  remove_all_reminder: "Odstrániť všetky úlohy",
  remove_all_confirm: "Naozaj chcete odstrániť všetky správy zo zoznamu vašich úloh?",
  remove_from_reminder: "Odstrániť z pripomienok",
  prevent_email: "E-mail nie je možné použiť ako používateľské meno.",
  allow_noti: "Povoľte prosím upozornenia.",
  join_cap: "Pripojiť sa",
  pass_minimum:
    "**Heslo vyžaduje 12 znakov vrátane malého a veľkého písmena, čísla a špeciálneho znaku.",
  pass_error: "Skontrolujte prosím požiadavky na heslo",
  people_that_like_article: "Ľudia, ktorým sa páči tento článok.",
  people_who_like_article: "Ľudia, ktorým sa páči váš článok.",
  message_delete: "Táto správa bola odstránená.",
  message_edited: "upravené",
  edit_message: "Upraviť správu",
  edit_window_expired: "Správy možno upraviť len do 10 minút po odoslaní.",
  message_edit_save: "Uložiť",
  copy: "Kopírovať",
  bookmark: "Záložka",
  add_reaction: "Pridať reakciu",
  delete_message: "Odstrániť správu",
  more_options: "Ďalšie možnosti",
  info: "Info",
  mark_unread: "Označiť ako neprečítané",
  reacted_with: "reagoval s",
  show_draft: "Zobraziť koncept...",
  draft_prefix: "Koncept:",
  delete_message_confirm: "Naozaj chcete odstrániť túto správu?",
  link_invite: "Pozvať cez odkaz",
  ll_nkk: "Pozvať do Kjuup",
  selected: "Vybrané",
  is_active: "Aktívny",
  inactive: "Neaktívny",
  last_online: "naposledy online {{when}}",
  remove_user_l: "Odstrániť",
  link_expire: "Každý vygenerovaný odkaz bude platný 72 hodín.",
  company_language: "Jazyk spoločnosti",
  company_language_info:
    "Výber jazyka sa použije pre všetky e-mailové potvrdenia týkajúce sa spoločnosti.",
  article_translation_target_languages_title: "Jazyky prekladu článkov",
  article_translation_target_languages_info:
    "Vyberte, do ktorých jazykov rozhrania Kjuup sa majú prekladať články tejto spoločnosti. Predvolene sú vybrané rovnaké jazyky ako pre externé články. Správcovia spoločnosti môžu tento zoznam zmeniť.",
  article_translation_target_languages_save: "Uložiť",
  article_translation_languages_saved: "Jazyky prekladu článkov uložené",
  article_original_language: "Pôvodný jazyk",
  article_original_language_info:
    "Jazyk, v ktorom je článok napísaný. Článok nebude preložený do tohto jazyka.",
  s_image: "obrázok",
  m_image: "obrázky",
  removeMsg: "Klepnutím odstránite",
  block: 'Zablokovať',
  unblock: 'Odblokovať',
  blocks: 'Naozaj chcete zablokovať tohto používateľa?',
  unblocks: 'Naozaj chcete odblokovať tohto používateľa?',
  bolcked_click_un_block:
    'Zablokovali ste tento kontakt. Kliknutím sem zrušíte blokovanie.',
  you_blocked_contact: 'Zablokovali ste tento kontakt.',
  you_unblocked_contact: 'Odblokovali ste tento kontakt.',
  you_have_unblocked: 'Odblokovali ste tento kontakt.',
  you_have_blocked: 'Zablokovali ste tento kontakt.',
  unblock_to_send: 'Odblokujte používateľa, aby ste mohli poslať správu.',
  pilot_text: "Špecializovaná AI pre stavebné témy",
  support_text: "Chatujte s podporou Kjuup",
  todo_notification_label: "Upozornenia na úlohy",
  todo_notification_info: "Budete upozornení vždy, keď vám bude priradená nová úloha.",
  daily_briefing_label: "Denný report",
  daily_briefing_info: "Vytvorí jeden denný manažérsky report pre všetky projekty v Správach v čase, ktorý nastavíte nižšie, ak máte pripojený e-mailový účet a aspoň jeden projekt mal aktivitu. Neodosiela sa e-mailom.",
  daily_briefing_notification_label: "Počítadlo upozornení pre Report",
  daily_briefing_notification_info: "Zobrazí počet neprečítaných reportov projektov na ikone projektov, na príslušnom projekte a na karte Report.",
  daily_briefing_hour_label: "Čas reportu",
  daily_briefing_hour_info: "Report sa vytvorí v tomto čase (Europe/Berlin). Ak dnešný čas už uplynul, vytvorí sa čoskoro.",
  daily_briefing_hour_saved: "Čas reportu bol aktualizovaný",
  room_daily_briefing_label: "Individuálny report projektu",
  room_daily_briefing_info: "Ak je zapnuté, každých 24 hodín v čase uvedenom v osobných nastaveniach sa vygeneruje report pre tento projekt — ale len vtedy, ak v danom období prebehla aktivita.",
  startup_screen_label: "Úvodná obrazovka",
  startup_screen_info: "Vyberte, ktorá obrazovka sa otvorí pri spustení Kjuup.",
  startup_screen_feed: "Home",
  startup_screen_messages: "Správy",
  startup_screen_saved: "Úvodná obrazovka aktualizovaná",
email_on: "E-mailové upozornenia na chaty",
  email_on_grp: "E-mailové upozornenie",
  article_email_on: "Email notification articles",
  article_email_info: "If you enable email notifications for internal articles, you will receive an email when a new internal article is published in your company and department.",
  info_email_room: "Aktivujte alebo deaktivujte e-mailové upozornenia pre tento projekt. Táto možnosť je dostupná iba vtedy, keď je v osobných nastaveniach zapnuté \"E-mailové upozornenia na chaty\".",
  info_val: "Dostanete e-mail, ak sa nová správa v chate neprečíta v krátkom čase. Môžete to vypnúť pre konkrétne projekty alebo chaty v ich nastaveniach alebo v informáciách o chatovej skupine.",
  email_groups: "Aktivujte alebo deaktivujte e-mailové upozornenia pre tento chat. Táto možnosť je dostupná iba vtedy, keď je zapnuté \"E-mailové upozornenia na chaty\" v osobných nastaveniach a nastaveniach projektu.",
  add_update_email: "Pridať/Aktualizovať e-mail",
  text_to_verifiy: "Možnosť \"E-mailové upozornenia na chaty\" je možné zapnúť iba vtedy, ak máte v zázname overenú e-mailovú adresu.",
  stored_email: "Uložený e-mail: ",
  verify_email: "Čaká sa na potvrdenie!",
  join_call:"Pripojiť sa",
  call_is_started:"Hovor sa začal",
  start_chat:"Začať priamy chat?",
  project_rooms:"Projekty",
  download_selected:"Stiahnuť",
  add_employee_confirm: 'Naozaj chcete pridať tohto používateľa do spoločnosti?',
  invalid_deeplink: "Neplatná adresa deeplinku. Chýbajú povinné parametre.",
  deeplink_error: "Nepodarilo sa spracovať deeplink. Skúste to prosím neskôr.",
  // Reply functionality translations
  reply: "Odpovedať",
  reply_enter: "Zadajte odpoveď...",
  reply_sent_successfully: "Odpoveď úspešne odoslaná",
  reply_failed: "Odoslanie odpovede zlyhalo",
  reply_failed_generic: "Odoslanie odpovede zlyhalo. Skúste to prosím znova.",
  replying_to_message: "Odpoveď na správu",
  cancel_reply: "Zrušiť odpoveď",
  voice_message: "Hlasová správa",
  send: "Odoslať",
  cancel: "Zrušiť",
  type_your_reply: "Napíšte svoju odpoveď...",
  
  // Auto-suggestion translations
  suggested_replies: "Navrhované odpovede",
  suggestions_error: "Nepodarilo sa načítať návrhy",
  positive_suggestion_placeholder: "Pozitívna",
  neutral_suggestion_placeholder: "Neutrálna",
  negative_suggestion_placeholder: "Negatívna",
  lazy_media_image: "Obrázok — kliknutím načítate",
  lazy_media_audio: "Hlasová správa — kliknutím načítate",
  lazy_media_doc: "Dokument — kliknutím načítate",
  lazy_media_video: "Video — kliknutím načítate",
  suggestion_loading_message: "Chvíľu strpenia. Váš text sa pre vás individuálne pripravuje.",
  loading_chat_message: "Načítava sa chat...",
  
  // Manual ToDo translations
  create_todo: "Vytvoriť úlohu",
  create_todo_confirmation: "Chcete z tejto správy vytvoriť úlohu?",
  select_project_required: "Vyberte prosím projekt/skupinu",
  only_assigned_can_change_status: "Stav môžu meniť iba priradení používatelia",
  todo_summary: "Zhrnutie",
  todo_summary_placeholder: "Zadajte zhrnutie úlohy...",
  todo_date: "Dátum",
  todo_time: "Čas",
  deadline: "Termín",
  todo_date_hint: "Nechajte prázdne, ak chcete použiť pôvodný dátum/čas správy",
  todo_created_success: "Úloha úspešne vytvorená",
  extracting_message: "Extrahovanie správy...",
  creating_todo: "Vytváranie úlohy...",
  bookmark_todo_creating: "Označená úloha sa vytvára...",
  navigating_to_todo: "Prechod na úlohu...",
  todo_creation_failed: "Vytvorenie úlohy zlyhalo",
  create: "Vytvoriť",
  
  image: "obrázok",
  images: "obrázky",
  remove_all_images: "Odstrániť všetky obrázky",
  remove_image: "Odstrániť obrázok",
  remove_document: "Odstrániť dokument",
  remove_recording: "Odstrániť nahrávku",
  play_recording: "Prehrať nahrávku",
  upload_image: "Nahrať obrázok",
  upload_document: "Nahrať dokument",
  record_audio: "Nahrať zvuk",
  stop_recording: "Zastaviť nahrávanie",
  stop_recording_text: "Zastaviť nahrávanie",
  please_remove_current_attachment: "Odstráňte prosím aktuálnu prílohu, aby ste",
  please_upload_image_file: "Nahrajte prosím platný obrazový súbor",
  please_upload_valid_document: "Nahrajte prosím platný dokumentový súbor",
  searching_messages: "Vyhľadávanie správ...",
  loading_more: "Načítava sa viac...",
  loading_more_users: "Načítava sa viac používateľov...",
  load_more_users: "Načítať viac používateľov",
  no_more_users_to_load: "Žiadni ďalší používatelia na načítanie",
  no_messages_found: "Nenašli sa žiadne správy",
  try_different_keyword: "Skúste iné kľúčové slovo alebo skontrolujte pravopis.",
  search_messages: "Hľadať správy, chaty, úlohy, projekty a používateľov...",
  search_messages_with_email: "Hľadať správy, e-maily, chaty, úlohy, projekty a používateľov...",
  search_groups: "Skupiny",
  search_chat_groups: "Chatové skupiny",
  search_project_room: "Projekt",
  search_messages_tab: "Správy",
  search_result_kjuup_chat: "Správy Kjuup Chat",
  search_users_tab: "Používatelia",
  search_documents_tab: "Dokumenty",
  no_media_available: "Žiadne súbory",
  no_documents_available: "No documents",
  searching_groups: "Vyhľadávanie skupín...",
  searching_rooms: "Vyhľadávanie projektov...",
  searching_users: "Vyhľadávanie používateľov...",
  no_groups_found: "Nenašli sa žiadne skupiny",
  no_rooms_found: "Nenašli sa žiadne projekty",
  no_users_found: "Nenašli sa žiadni používatelia",
  search_emails_tab: "E-mail",
  searching_emails: "Vyhľadávanie e-mailov...",
  no_emails_found: "Nenašli sa žiadne e-maily",
  search_email_addresses_tab: "E-mail adresy",
  search_email_content_tab: "E-mail obsah",
  searching_email_content: "Hľadá sa obsah e-mailu...",
  no_email_content_found: "Nenašiel sa obsah e-mailu",
  search_email_attachments_tab: "E-mail prílohy",
  searching_email_attachments: "Hľadajú sa prílohy...",
  no_email_attachments_found: "Nenašli sa žiadne zhody príloh",
  email_attachments_label: "Prílohy",
  searching_email_addresses: "Hľadajú sa adresy...",
  no_email_addresses_found: "Nenašli sa žiadne zhody adries",
  search_email_filter_all: "Všetky",
  search_email_filter_content: "Obsah",
  search_email_filter_addresses: "Adresy",
  search_email_filter_attachments: "Prílohy",
  search_email_filter_has_attachments: "S prílohami",
  search_email_filter_unread: "Neprečítané",
  search_email_combo_placeholder: "V e-mailoch od (voliteľné)…",
  search_email_combo_content_placeholder: "Hľadať v týchto e-mailoch…",
  search_email_combo_hint: "Hľadanie v e-mailoch od",
  search_email_combo_containing: "obsahujúce",
  search_describe: "Opíšte, čo hľadáte…",
  search_describe_examples_with_email: "napr. e-maily od ml@bl2020.com s heslom · správy od Martina o faktúre · používateľ Martin Langen",
  search_intent_understood: "Hľadanie",
  search_intent_emails: "E-maily",
  search_intent_messages: "Správy",
  search_intent_user: "Používateľ",
  search_submit: "Hľadať",
  email_subject_label: "Predmet",
  email_body_label: "Text",
  email_address_received: "Prijaté",
  email_address_sent: "Odoslané",
  search_todos_tab: "Úloha",
  no_todos_found: "Nenašli sa žiadne úlohy",
  todo: "Úloha",
  np_todo: "Žiadne úlohy",
  move_to_todo: "Uložiť ako úlohu",
  remove_todo: "Naozaj chcete odstrániť túto úlohu?",
  remove_all_todo: "Odstrániť všetky úlohy",
  remove_all_todo_confirm: "Naozaj chcete odstrániť všetky úlohy?",
  add_to_todo: "Pridať k úlohám",
  remove_from_todo: "Odstrániť z úloh",
  confirm: "Potvrdiť",
  ok: "Ok",
  read_more: "Čítať viac",
  show_less: "Zobraziť menej",
  show_more: "Zobraziť viac",
  audio: "Zvuk",
  video: "Video",
  // Notification Settings
  notification_schedule: "Rozvrh upozornení",
  notification_schedule_desc: "Push a e-mailové upozornenia budete dostávať iba v hodinách, ktoré si zvolíte. Mimo týchto časov budú pozastavené.",
  company_notification_schedule_desc: "Nastavte časy upozornení pre všetkých členov spoločnosti. Toto prepíše osobné nastavenia upozornení každého člena.",
  learn_more: "Zistiť viac",
  allow_notifications: "Povoliť upozornenia:",
  every_day: "Každý deň",
  weekdays: "Pracovné dni (pondelok až piatok)",
  custom: "Vlastné",
  monday: "Pondelok",
  tuesday: "Utorok",
  wednesday: "Streda",
  thursday: "Štvrtok",
  friday: "Piatok",
  saturday: "Sobota",
  sunday: "Nedeľa",
  to: "do",
  notification_settings: "Upozornenia",
  notification_settings_saved: "Nastavenia upozornení úspešne uložené",
  notification_settings_error: "Uloženie nastavení upozornení zlyhalo",
  unavailability_note: "Poznámka o neprítomnosti",
  unavailability_description: "Nastavte poznámku mimo kancelárie. Kým je aktívna, poznámka sa zobrazuje ostatným vo všetkých vašich chatoch a upozornenia sú pozastavené.",
  unavailability_start_date: "Dátum začiatku",
  unavailability_end_date: "Dátum konca",
  unavailability_message: "Správa",
  unavailability_message_hint: "Použite {endDate} ako zástupný symbol pre dátum vášho návratu.",
  unavailability_replacement: "Zastupujúci kontakt",
  unavailability_replacement_placeholder: "Zadajte ID používateľa pre naliehavé žiadosti",
  unavailability_replacement_current: "Aktuálne zastupovanie",
  unavailability_replacement_hint: "Ak je nastavené, vo vašej poznámke o neprítomnosti sa zobrazí odkaz na kontaktovanie tejto osoby pre naliehavé záležitosti.",
  unavailability_replacement_none: "Žiadne zastupovanie (voliteľné)",
  unavailability_contact_urgent: "Pri naliehavých žiadostiach kontaktujte",
  unavailability_default_message: "Momentálne som mimo kancelárie a nemám prístup ku Kjuup. Znova budem k dispozícii od {endDate} a potom sa vám ozvem.",
  unavailability_save: "Uložiť",
  unavailability_deactivate: "Deaktivovať",
  unavailability_active_until: "Aktívne do",
  unavailability_saved: "Poznámka o neprítomnosti uložená",
  unavailability_save_error: "Uloženie poznámky o neprítomnosti zlyhalo",
  unavailability_deactivated: "Poznámka o neprítomnosti deaktivovaná",
  unavailability_end_date_required: "Dátum konca je povinný",
  start_time_before_end_time: "Čas začiatku musí byť pred časom konca",
  loading: "Načítava sa",
  disabled: "Zakázané",
  enable: "Povoliť",
  disable: "Zakázať",
  forwarded: "Preposlané",
  message_forwarded: "Správa preposlaná!",
  // Schedule Article
  schedule_article_post: "Naplánovať uverejnenie článku",
  date: "Dátum",
  time: "Čas",
  scheduled_for_publication: "Naplánované na uverejnenie",
  article_will_be_published_on: "Článok bude uverejnený dňa:",
  reset_selection: "Obnoviť výber",
  continue: "Pokračovať",
  cancel: "Zrušiť",
  // Member Selection
  error_loading_members: "Chyba pri načítavaní členov",
  please_fill_all_fields: "Vyplňte prosím všetky polia",
  invalid_email: "Neplatná e-mailová adresa",
  member_added_successfully: "Člen úspešne pridaný",
  error_onboarding_user: "Chyba pri pridávaní používateľa",
  error_creating_chat: "Chyba pri vytváraní chatu",
  error_creating_group: "Chyba pri vytváraní skupiny",
  new_group: "Nová skupina",
  please_select_or_enter_group_name: "Vyberte skupinu alebo zadajte názov skupiny",
  please_select_or_enter_room_name: "Vyberte projekt alebo zadajte názov projektu",
  error_creating_room: "Chyba pri vytváraní projektu",
  error_opening_chat: "Chyba pri otváraní chatu",
  privacy_modal_text: "Vyberte \"Súkromné\" iba vtedy, ak chat neobsahuje žiadny relevantný odborný obsah pre projektového manažéra.",
  not_private: "Nie súkromné",
  private: "Súkromné",
  error_loading_groups: "Chyba pri načítavaní skupín",
  automatic_chat_export: "Automatický export chatu",
  automatic_chat_export_info: "Po aktivácii sa história chatu bude každý mesiac automaticky posielať na zadanú e-mailovú adresu.",
  automatic_chat_export_no_email: "Ak chcete aktivovať automatický export chatu, musíte najprv pridať e-mailovú adresu. E-mailovú adresu môžete pridať v osobných nastaveniach.",
  enter_email: "Zadajte e-mail",
  update: "Aktualizovať",
  confirm: "Potvrdiť",
  export_to_email: "Export sa odošle na nasledujúci e-mail.",
  start_chat_button:"Nová správa",
  start_direct_message: "Začať priamu správu?",
  matching_existing_chats: "Zhodujúce sa existujúce chaty",
  subject: "Predmet",
  add_subject: "Pridať predmet",
  chat_subject: "Predmet chatu:",
  set_project_room: "Nastaviť projekt",
  matching_existing_project_rooms: "Zhodujúce sa existujúce projekty",
  name_project_room: "Názov projektu",
  professional_or_private: "Odborné alebo súkromné",
  professional: "Odborné",
  privacy_modal_text_updated: "Vyberte \"Súkromné\" iba vtedy, ak chat neobsahuje relevantný odborný obsah pre projektových manažérov. Súkromné chaty nie sú pre projektových manažérov viditeľné.",
  create_internal_chat: "Externý alebo interný chat?",
  internal_chat_description: "Do interných chatov je možné pridať iba zamestnancov vašej spoločnosti.",
  yes: "Áno",
  no: "Nie",
  chat_is_being_created: "Chat sa vytvára...",
  // Additional translations for hardcoded text
  discard_article_confirm: "Naozaj chcete zahodiť zmeny v tomto článku?",
  save_article_as_draft_confirm: "Chcete uložiť tento článok ako koncept?",
  please_enter_article_title: "Najprv prosím zadajte názov článku.",
  please_add_mandatory_fields: "Pridajte prosím všetky povinné polia",
  product_label: "Produkt:",
  no_companies_found: "Nenašli sa žiadne spoločnosti",
  visible_to_all_followers: "Viditeľné pre všetkých členov Kjuup",
  only_visible_to_employees: "Viditeľné iba pre zamestnancov",
  something_went_wrong: "Niečo sa pokazilo, skúste to prosím znova",
  please_select_department: "Vyberte prosím oddelenie/lokalitu",
  schedule: "Naplánovať",
  please_select_future_date_time: "Vyberte prosím budúci dátum a čas na naplánovanie článku.",
  please_select_different_date_time: "Vyberte prosím iný dátum alebo čas na naplánovanie článku.",
  please_select_later_time: "Vyberte prosím čas neskorší ako aktuálny čas pre dnešný deň.",
  unpin_article: "Odopnúť článok",
  pin_article: "Pripnúť článok",
  and: "a",
  others: "ďalší",
  at: "o",
  // Chat mute/unmute translations
  mute: "Stlmiť",
  unmute: "Zrušiť stlmenie",
  chat_muted_successfully: "Chat úspešne stlmený",
  chat_unmuted_successfully: "Stlmenie chatu úspešne zrušené",
  mute_chat_confirm: "Naozaj chcete stlmiť tento chat? Nebudete už dostávať upozornenia na nové správy.",
  unmute_chat_confirm: "Naozaj chcete zrušiť stlmenie tohto chatu? Znova budete dostávať upozornenia na nové správy.",
  please_select_group_to_forward: "Vyberte skupinu na preposlanie správy",
  // Company translations
  record_not_found: "Záznam sa nenašiel!",
  please_select_position: "Vyberte prosím pozíciu",
  delete_article_confirm: "Naozaj chcete odstrániť tento článok?",
  delete_company_service_confirm: "Naozaj chcete odstrániť službu spoločnosti?",
  block_translation_confirm: "Naozaj chcete zablokovať automatický preklad v projektoch pre všetkých členov spoločnosti",
  unblock_translation_confirm: "Naozaj chcete odblokovať automatický preklad v projektoch pre všetkých členov spoločnosti",
  please_select_file: "Vyberte prosím súbor na nahranie",
  role_in_building_industry: "Rola v stavebnom priemysle*",
  invalid_email_address: "Neplatná e-mailová adresa",
  please_enter_password: "Zadajte prosím heslo",
  password_change_email_sent: "Na váš e-mail Kjuup bol odoslaný e-mail. Potvrďte svoje nové heslo kliknutím na potvrdzovací odkaz v e-maile.",
  please_enter_username: "Zadajte prosím používateľské meno",
  username_same_as_before: "Používateľské meno nemôže byť rovnaké ako predtým",
  profile_deleted_successfully: "Profil úspešne odstránený",
  hardware_requirements: "Hardvérové požiadavky",
  hardware_requirements_list: "• 4 GB RAM<br/>• Rýchlosť CPU min. 2 GHz<br/>• Windows 7 alebo vyšší / všetky verzie macOS",
  submitting: "Odosiela sa...",
  signing_in: "Prihlasovanie...",
  please_enter_service_name: "Zadajte prosím názov služby",
  something_went_wrong_error: "Ajaj! Niečo sa pokazilo...",
  something_went_wrong_try_again: "Prepáčte, niečo sa pokazilo. Skúste to znova",
  position_label: "Pozícia:",
  loading_room: "Načítava sa projekt...",
  navigating_to_room: "Prechod do projektu",
  loading_chat: "Načítava sa chat...",
  translate: "Preložiť",
  show_original: "Zobraziť originál",
  show_translation: "Zobraziť preklad",
  click_to_show_original: "Kliknutím zobrazíte originál",
  click_to_show_translation: "Kliknutím zobrazíte preklad",
  saving: "Ukladá sa...",
  language_selection_info: "Výber jazyka sa použije pre všetky e-mailové potvrdenia týkajúce sa spoločnosti.",
  // Navigation bar labels
  nav_call: "Hovor",
  nav_home: "Domov",
  nav_messages: "Správy",
  nav_todo: "Úlohy",
  nav_rooms: "Projekty",
  nav_all_rooms: "Všetky projekty",
  pinned_rooms_max: "Môžete pripnúť až 10 projektov.",
  pinned_room_unpin: "Odopnúť",
  pinned_rooms_drop: "Presuňte projekt sem pre rýchly výber",
  nav_profile: "Profil",
  nav_company: "Spoločnosť",
  nav_company_documents: "Dokumenty",
  nav_logout: "Odhlásiť sa",
  // Create message dialog
  add_member_title: "Pridať člena",
  continue_btn: "Pokračovať",
  search_placeholder: "Hľadať",
  no_members_found: "Nenašli sa žiadni členovia",
  no_groups_found: "Nenašli sa žiadne skupiny",
  no_rooms_found: "Nenašli sa žiadne projekty",
  unnamed_group: "Nepomenovaná skupina",
  unnamed_room: "Nepomenovaný projekt",
  all_members: "Všetci",
  room_label: "Projekt:",
  subject_label: "Predmet:",
  no_members: "Žiadni členovia",
  // Loading states for room creation
  creating_structure: "Vytváranie vašej štruktúry",
  opening_chat: "Otváranie chatu",
  please_wait: "Čakajte prosím...",
  // Loading states for company join
  sending_request: "Odosielanie žiadosti",
  updating_profile: "Aktualizácia profilu",
  // ToDo page translations
  loading_todo: "Načítava sa úloha...",
  task_updated: "Úloha aktualizovaná",
  error_updating_task: "Chyba pri aktualizácii úlohy",
  task_deleted: "Úloha odstránená",
  error_deleting_task: "Chyba pri odstraňovaní úlohy",
  delete_task_confirm: "Naozaj chcete odstrániť túto úlohu?",
  delete_multiple_tasks_confirm: "Naozaj chcete odstrániť {count} úloh?",
  delete_selected_count: "Odstrániť ({count})",
  todo_multi_delete: "Odstrániť viacero",
  todo_multi_delete_hint: "Vyberte úlohy na odstránenie",
  todos_deleted_count: "{count} úloh odstránených",
  todos_deleted_partial: "{ok} úloh odstránených, {fail} zlyhalo",
  delete_only_own: "Môžete odstrániť iba úlohy, ktoré ste vytvorili",
  description_label: "Popis",
  description_placeholder: "Zadajte popis...",
  date_time_label: "Dátum a čas",
  save_hint: "Ctrl+Enter pre uloženie, Esc pre zrušenie",
  edit_label: "Upraviť",
  delete_label: "Odstrániť",
  todo_list_title: "Úlohy",
  tasks_count: "úloh",
  search_placeholder_todo: "Hľadať...",
  select_task_to_open_chat: "Vyberte úlohu na otvorenie chatu",
  today: "Dnes",
  yesterday: "Včera",
  time_suffix: "", // Prázdne pre slovenčinu (24-hodinový formát nepotrebuje príponu)
  from_chat: "Zdrojová úloha",
  assigned_to: "Priradené používateľovi",
  assign_users: "Priradiť používateľov",
  assigned_users: "Priradení používatelia:",
  no_users_assigned: "Žiadni priradení používatelia",
  assign: "Priradiť",
  assign_to: "Priradiť...",
  navigate_to_chat: "Prejsť na chat",
  navigate_to_email: "Prejsť na e-mail",
  show_original_message: "Zobraziť zdroj",
  hide_original_message: "Skryť zdroj",
  status_pending: "Čaká sa",
  status_in_progress: "Prebieha",
  status_completed: "Dokončené",
  show: "Zobraziť",
  close: "Zavrieť",
  // Additional ToDo translations
  todo_beta: "BETA",
  todo_project_label: "Projekt:",
  todo_chat_label: "Chat:",
  todo_assigned_by: "Priradil:",
  todo_assigned_push: "Priradené ToDo:",
  todo_assigned_push_empty: "Bolo vám priradené nové ToDo.",
  todo_clear_all: "Vymazať všetko",
  todo_unknown: "Neznáme",
  filter_all: "Všetko",
  filter_assigned_to_me: "Moje úlohy",
  filter_assigned_by_me: "Delegované",
  completed_by: "Dokončil:",
  verify_completion: "Overiť",
  back_into_in_progress: "Späť do prebiehajúcich",
  unassign_todo: "Zrušiť priradenie úlohy",
  unassign_label: "Zrušiť priradenie",
  me: "Ja",
  search_or_select_project: "Vyhľadať alebo vybrať projekt...",
  // Confirmed ToDo and History translations
  status_confirmed: "Potvrdené",
  history: "História",
  marked_as: "Označené ako",
  at_date: "o",
  at_time: "o",
  time_suffix: "",
  all_todos: "Otvorené úlohy",
  confirmed_todos: "Potvrdené úlohy",
  filter_pending: "Čaká sa",
  filter_confirmed: "Potvrdené",
  my_list: "Môj deň",
  todo_adjust_list: "Upraviť zoznam",
  apply: "Použiť",
  move_back_in_progress: "Presunúť späť do prebiehajúcich",
  no_history_yet: "Zatiaľ žiadna história",
  todo_status_updated: "Stav úlohy aktualizovaný z {from} na {to}",
  todo_status_updated_from: "z",
  todo_status_updated_to: "na",
  // Log description translations
  log_todo_created: "Úloha vytvorená",
  log_todo_confirmed: "Úloha potvrdená",
  log_todo_deleted: "Úloha odstránená",
  log_todo_updated: "Úloha aktualizovaná",
  log_description_updated: "Popis aktualizovaný",
  log_deadline_updated: "Termín aktualizovaný",
  log_assigned_to: "Priradené používateľovi {name}",
  log_unassigned_from: "Zrušené priradenie od {name}",
  log_assignment_added: "Priradenie pridané: {name}",
  log_assignment_removed: "Priradenie odstránené: {name}",
  log_status_updated: "Stav zmenený z {from} na {to}",
  log_status_changed: "Stav zmenený",
  log_status_changed_to: "Stav zmenený na {status}",
  log_changed_status_to: "Zmenil stav na:",
  log_for_user: "pre používateľa:",
  log_user_updated_status: "Používateľ aktualizoval stav svojej úlohy",
  log_changed_date_to: "Zmenil dátum na:",
  log_changed_description_to: "Zmenil popis na:",
  log_moved_to: "Presunuté do {status}",
  // ToDo filter translations
  todo_filters: "Filtre",
  todo_filter_by_project: "Filtrovať podľa projektu",
  todo_status: "Stav",
  todo_assignment: "Priradenie",
  todo_filter_by_user: "Filtrovať podľa priradenej osoby",
  todo_active_filters: "Aktívne filtre:",
  todo_progress: "Priebeh",
  todo_my_list_empty: "Váš deň je prázdny",
  todo_my_list_empty_hint: "Kliknutím na tlačidlo vyššie pridáte úlohy",
  create_poll: "Anketa",
  poll_question_label: "OTÁZKA",
  poll_question_placeholder: "Položte otázku",
  poll_options_label: "MOŽNOSTI",
  poll_option: "Možnosť",
  poll_add_option: "Pridať možnosť",
  poll_allow_multiple: "Povoliť viacero odpovedí",
  poll_multiple_allowed: "Vyberte jednu alebo viac možností",
  poll_select_option: "Vyberte jednu možnosť",
  poll_view_votes: "Zobraziť hlasy",
  poll_vote_singular: "hlas",
  poll_vote_plural: "hlasov",
  poll_votes: "Hlasy ankety",
  poll_no_votes_yet: "Zatiaľ žiadne hlasy",
  transcript_label: "Prepis",
  ai_generated_transcription: "Prepis generovaný AI",
  transcript_start: "Prepísať hlasovú správu",
  transcript_transcribing: "Prepisuje sa...",
  transcript_show: "Zobraziť prepis",
  transcript_hide: "Skryť prepis",
  transcript_redo: "Zopakovať prepis",
  transcript_failed: "Prepis zlyhal",
  transcript_no_result: "Nevrátil sa žiadny prepis",
  transcript_step_listening: "Počúvanie hlasovej správy...",
  transcript_step_processing: "Prebieha prepis...",
  transcript_step_creating: "Vytváranie textu...",
  ai_transcript_tab: "AI prepis",
  ai_transcript_info: "Dostupné iba pre hlasové správy vytvorené po 09.03.2026.",
  no_transcript_available: "Prepis nie je k dispozícii.",
  transcript_more: "...viac",
  transcript_less: "...menej",
  ki_transcript_voice_message: "AI prepis hlasovej správy",
  ki_image_analysis: "Analýza obrázka pomocou AI",
  document_analysis: "Analýza dokumentu",
  type_message: "Napíšte správu",
  email_tab_messages: "Správy",
  email_tab_email: "E-mail",
  email_tab_messages_and_email: "Správy a e-mail",
  email_tab_email_details: "Podrobnosti e-mailu",
  email_accounts: "E-mailové účty",
  email_connect_gmail: "Pripojiť Gmail",
  email_connect_outlook: "Pripojiť Outlook",
  email_no_accounts: "Nie sú pripojené žiadne e-mailové účty",
  email_no_accounts_hint: "Pripojte e-mailový účet v nastaveniach profilu",
  email_no_messages: "Žiadne e-maily",
  email_from: "Od",
  email_to: "Komu",
  email_subject: "Predmet",
  email_disconnect: "Odpojiť",
  email_disconnect_confirm: "Naozaj chcete odpojiť tento e-mailový účet? Všetky synchronizované e-maily budú odstránené.",
  email_account_disconnected: "E-mailový účet úspešne odpojený",
  email_account_disconnect_failed: "Odpojenie účtu zlyhalo",
  email_connecting: "Pripája sa...",
  email_account_connected: "Účet úspešne pripojený",
  email_connected_accounts: "Pripojené účty",
  email_sync_info: "Pri pripojení e-mailového účtu sa predvolene synchronizujú e-maily za posledný mesiac. Obdobie synchronizácie môžete predĺžiť nižšie.",
  email_sync_3_months: "Synchronizovať posledné 3 mesiace",
  email_sync_6_months: "Synchronizovať posledných 6 mesiacov",
  email_syncing: "Synchronizuje sa...",
  email_sync_already_done: "{months} mesiacov už synchronizovaných",
  email_sync_more: "Synchronizovať ďalšie mesiace",
  email_sync_all_done: "Všetky mesiace synchronizované",
  email_syncing_account: "Synchronizuje sa účet, môže to trvať niekoľko minút…",
  email_signature: "Podpis",
  email_signature_placeholder: "Zadajte svoj e-mailový podpis...",
  email_signature_save: "Uložiť",
  email_signature_saved: "Uložené",
  email_add_account: "Pridať účet",
  email_folder_inbox: "Doručená pošta",
  email_folder_spam: "Spam",
  email_folder_drafts: "Koncepty",
  email_folder_sent: "Odoslané položky",
  email_folder_deleted: "Odstránené položky",
  email_folder_archive: "Archív",
  email_folder_outbox: "Pošta na odoslanie",
  email_custom_folders: "Priečinky",
  email_create_folder: "Nový priečinok",
  email_delete_folder: "Odstrániť priečinok",
  email_folder_name_placeholder: "Názov priečinka",
  email_folder_created: "Priečinok vytvorený",
  email_folder_deleted: "Priečinok odstránený",
  email_move_to: "Presunúť do",
  email_moved_to_folder: "Presunuté do priečinka",
  email_move_to_inbox: "Presunúť do doručenej pošty",
  email_confirm_delete_folder: "Naozaj chcete odstrániť tento priečinok?",
  email_refresh: "Obnoviť",
  email_folder_not_synced: "Tento priečinok sa automaticky nesynchronizuje.",
  email_sync_folder: "Synchronizovať teraz",
  email_go_to_settings: "Prejsť do nastavení",
  email_date: "Dátum",
  email_reply: "Odpovedať",
  email_forward: "Preposlať",
  email_copy_text: "Kopírovať text",
  email_text_copied: "Skopírované!",
  email_text_copy_failed: "Text sa nepodarilo skopírovať.",
  email_delete: "Odstrániť",
  email_not_spam: "Nie je spam",
  email_not_spam_success: "E-mail presunutý do doručenej pošty.",
  email_not_spam_failed: "Presun do doručenej pošty zlyhal.",
  email_delete_confirm: "Naozaj chcete odstrániť tento e-mail?",
  email_delete_from_folder: "Naozaj chcete odstrániť z priečinka {folder}?",
  email_delete_permanent_from_folder:
    "Naozaj chcete natrvalo odstrániť z priečinka {folder}? Túto akciu nie je možné vrátiť späť.",
  email_save_draft_confirm: "Chcete uložiť tento e-mail ako koncept?",
  email_save_draft: "Uložiť koncept",
  email_discard: "Zahodiť",
  email_back_to_compose: "Späť k písaniu",
  email_draft_saved: "Koncept uložený.",
  email_saving_draft: "Ukladanie konceptu...",
  email_draft_save_failed: "Uloženie konceptu zlyhalo.",
  email_loading: "Načítavanie e-mailov...",
  email_imap_title: "IMAP",
  email_imap_hint: "Pripojte akýkoľvek e-mailový účet cez IMAP.",
  email_imap_user: "E-mail",
  email_imap_password: "Heslo",
  email_imap_connect_btn: "Pripojiť účet IMAP",
  email_imap_required: "Zadajte prosím e-mail a heslo.",
  email_imap_failed: "Pripojenie IMAP zlyhalo.",
  email_imap_manual_toggle: "Manuálne nastavenia servera",
  email_imap_host: "Server IMAP (napr. imap.ionos.de)",
  email_imap_port: "Port",
  email_imap_incoming: "Prichádzajúca pošta (IMAP)",
  email_smtp_outgoing: "Odchádzajúca pošta (SMTP)",
  email_smtp_host: "Server SMTP (napr. smtp.ionos.de)",
  email_smtp_port: "Port",
  email_send_btn: "Odoslať",
  email_sent: "E-mail odoslaný.",
  email_sending: "Odosielanie e-mailu...",
  deleting_emails: "Odstraňovanie e-mailu...",
  marking_unread: "Označovanie ako neprečítané...",
  email_send_failed: "Odoslanie e-mailu zlyhalo.",
  email_compose_to_required: "Príjemca (Komu) je povinný.",
  email_compose_body_required: "Zadajte prosím predmet alebo telo správy.",
  email_compose_placeholder: "Napíšte svoju správu...",
  email_original_message: "Pôvodná správa",
  email_forwarded_message: "Preposlaná správa",
  email_archived: "Archivované",
  email_mark_spam: "Označiť ako spam",
  email_marked_spam: "Označené ako spam",
  email_group_today: "Dnes",
  email_group_yesterday: "Včera",
  email_group_this_week: "Tento týždeň",
  email_group_earlier: "Skôr",
  email_search: "Hľadať",
  email_search_placeholder: "Hľadať poštu",
  email_no_results: "Žiadne zodpovedajúce správy",
  email_clear_search: "Vymazať vyhľadávanie",
  email_star: "Označiť hviezdičkou",
  email_unstar: "Odstrániť hviezdičku",
  email_starred: "Označené hviezdičkou",
  email_folder_starred: "Označené hviezdičkou",
  email_select: "Vybrať",
  email_attachment_singular: "Príloha",
  email_attachment_plural: "Prílohy",
  email_back: "Späť",
  email_download: "Stiahnuť",
  email_download_all: "Stiahnuť všetko",
  email_download_all_zip: "Stiahnuť všetko ako ZIP",
  email_close: "Zavrieť",
  email_preview: "Náhľad",
  email_preview_not_available: "Náhľad nie je k dispozícii",
  email_preview_failed: "Náhľad nie je k dispozícii",
  email_loading_preview: "Načítavanie náhľadu...",
  email_no_subject: "(Bez predmetu)",
  email_mark_unread_failed: "e-mail(y) sa nepodarilo označiť ako neprečítané.",
  email_delete_failed: "e-mail(y) sa nepodarilo odstrániť.",
  // Email-to-project classification
  email_classify_banner: "{count} e-mailov od nových odosielateľov vyžaduje klasifikáciu",
  email_classify_review: "Skontrolovať",
  email_classify_title: "Klasifikovať nového odosielateľa",
  email_classify_question_project: "Súvisí tento e-mail s projektom?",
  email_project_name: "Názov projektu",
  email_classify_suggested: "Navrhované",
  email_remember_sender: "Zapamätať si tohto odosielateľa pre budúce e-maily",
  email_account_default_project: "Vždy priradiť e-maily z tohto účtu k tomuto projektu",
  email_classify_associate: "Priradiť k projektu",
  email_classify_missing: "Nepriradené",
  email_tag_daily_briefing: "Report",
  email_project_navigate: "Prejsť na projekt",
  email_project_change: "Zmeniť priradenie projektu",
  email_project_remove: "Odstrániť priradenie projektu",
  email_project_removed: "Priradenie projektu odstránené",
  email_classify_question_spam: "Ide o SPAM alebo reklamu?",
  email_classify_mark_spam: "Presunúť do spamu",
  email_classify_skip: "Zatiaľ preskočiť",
  email_classify_need_project: "Zadajte prosím názov projektu",
  email_classify_refile_question: "Mám túto e-mail znovu zaradiť do projektu '{name}'?",
  email_classify_refile_yes: "Áno, zaradiť do '{name}'",
  email_classify_choose_other: "Vybrať iný projekt",
  email_saved_to_project: "E-mail uložený do projektu",
  email_saved_to_project_similar: "E-mail uložený do projektu. {count} podobných e-mailov bolo tiež priradených.",
  email_room_tab: "E-Mail",
  email_room_tab_all: "Všetko",
  email_room_tab_todos: "Úlohy",
  email_room_tab_briefings: "Report",
  email_room_all_empty: "V tomto projekte zatiaľ nie sú žiadne správy",
  email_room_briefings_empty: "V tomto projekte zatiaľ nie sú žiadne reporty",
  email_room_empty: "V tomto projekte zatiaľ nie sú žiadne e-maily",
  email_room_sent_empty: "V tomto projekte zatiaľ nie sú žiadne odoslané e-maily",
  email_room_drafts_empty: "V tomto projekte zatiaľ nie sú žiadne koncepty",
  email_room_inbox: "Doručená pošta",
  email_room_sent: "Odoslané",
  email_room_drafts: "Koncepty",
  email_room_remove: "Odstrániť z projektu",
  email_room_remove_confirm: "Odstrániť tento e-mail z projektu?",
  email_room_briefing_remove_confirm: "Naozaj chceš odstrániť tento report?",
  email_room_removed: "E-mail odstránený z projektu",
  email_compose_project: "Priradenie projektu v Kjuup",
  email_compose_project_info:
    "Táto informácia je viditeľná len pre teba a nebude odoslaná s e-mailom.",
  email_compose_project_placeholder: "Názov projektu",
  email_no_sender: "(neznámy odosielateľ)",
  email_no_recipient: "(žiadny príjemca)",
  email_attachments_tab: "E-MAIL",
  select_attachments: "Vybrať prílohy",
  email_attachments_empty: "Zatiaľ žiadne e-mailové prílohy",
  email_move_to_room: "Presunúť do projektu",
  email_attachment_moved: "E-mailová príloha presunutá",
  email_attachment_removed: "E-mailová príloha odstránená",
  email_attachment_remove_confirm: "Odstrániť vybrané e-mailové prílohy z tohto projektu?",
  email_no_other_rooms: "Nie sú k dispozícii žiadne ďalšie projekty",
  email_classify_rules_title: "Pravidlá klasifikácie e-mailov",
  email_default_project_per_account: "Predvolený projekt na účet",
  email_sender_rules: "Pravidlá odosielateľov",
  email_spam_blocklist: "Zoznam blokovaných spamov",
  email_no_default: "Žiadny",
  email_select_project: "Vybrať projekt",
  attachment: "príloha",
  attachments: "prílohy",
  media_send_disabled: "Zakázané správcom.",
  todo_bookmarked: "Úloha bola označená",
  bookmarked_todos: "Úlohy v záložkách",
  needs_date: "Priradiť dátum",
  needs_date_hint: "Nastavte dátum, aby ste úlohu naplánovali",
  bookmarked_no_mylist: "Úlohy v záložkách nie je možné pridať do Môjho zoznamu",
  bookmark_removed: "Záložka odstránená",
  bookmark_already_todo: "Táto úloha už bola upravená a zostane zachovaná",
  new_label: "Nové",
  no_new_todos: "Žiadne nové úlohy",
  filter_all: "Všetko",
  filter_email: "E-mail",
  filter_reports: "Reporty",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "Priame správy",
  my_notes: "My Space",
  filter_internal_groups: "Interné skupinové chaty",
  filter_external_groups: "Externé skupinové chaty",
  filter_group_chats: "Skupinové chaty",
  filter_groups_internal: "Interné",
  filter_groups_external: "Externé",
  filter_unread_only: "Iba neprečítané",
  email_select_all: "Vybrať všetko",
  email_deselect_all: "Zrušiť výber všetkých",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'Predplatiť teraz',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1 MESIAC ZADARMO',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'Dnes žiadna platba. Údaje o kreditnej karte sa nevyžadujú, kým nezačne platené predplatné.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'Spravujte všetky e-mailové účty priamo v Kjuupe',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'AI píše odpovede – vy len potvrdíte',
  kjuup_io_feature_tasks: 'Úlohy a kalendár vždy automaticky aktuálne',
  kjuup_io_choose_plan: 'Vyberte plán',
  kjuup_io_plan_monthly: 'Mesačne',
  kjuup_io_plan_yearly: 'Ročne',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Zabezpečené cez Stripe · zrušenie kedykoľvek',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'Platba prijatá. Predplatné sa aktivuje…',
  kjuup_io_toast_activating_soon: 'Platba prijatá. Vaše predplatné bude čoskoro aktivované.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: 'Zostáva {count} h',
  kjuup_io_trial_left_hour: 'Zostáva 1 hodina',
  kjuup_io_trial_left_minutes: 'Zostáva {count} min',
  kjuup_io_trial_left_minute: 'Zostáva 1 minúta',
  kjuup_io_trial_left_seconds: 'Zostáva {count} s',
  kjuup_io_trial_left_second: 'Zostáva 1 sekunda',
  kjuup_io_trial_ending_now: 'Skúšobné obdobie sa končí…',
  kjuup_io_request_timeout: 'Časový limit pripojenia vypršal. Skúste to znova.',
  kjuup_io_info_days_free: '{days} dní úplne zadarmo – predplatné začína až po skúšobnej dobe.',
  kjuup_io_discount_total: 'Vaša zľava: {percent} %',
  kjuup_io_discount_company: '{company}: {percent} %',
  kjuup_io_discount_personal: 'Osobná: {percent} %',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'Zavrieť',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'Vaše bezplatné skúšobné obdobie sa skončilo',
  kjuup_io_trial_ended_body: 'Predplaťte si Kjuup.io, aby ste mohli ďalej používať e-mail a ďalšie prémiové funkcie.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'Vaše bezplatné skúšobné obdobie sa začalo',
  kjuup_io_toast_trial_fail: 'Skúšobné obdobie sa nepodarilo spustiť',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / mesiac',
  kjuup_io_save_amount_year: 'Ušetrite {price} ročne',
  kjuup_io_billed_annually_amount: '{price} účtované ročne',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'Čo získate:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'Kreditná karta nie je potrebná – začnite hneď bez platobných údajov.',
  kjuup_io_info_cancel_anytime: 'Zrušte kedykoľvek – žiadny záväzok, žiadne riziko.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'Zúčtovacie obdobie',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'Spôsob platby uložený. Platba bude stiahnutá na konci skúšobného obdobia.',
  calendar_sync_info: 'Automaticky synchronizuj všetky Kjuup ToDo s tvojím kalendárom.',
  calendar_no_accounts: 'Zatiaľ nie je pripojený žiadny kalendár.',
  article_new_badge: 'NOVÉ',
  article_new_posts: '{0} nových príspevkov',
  documents: 'Dokumenty',
  add_documents: 'Pridať dokumenty',
  no_preview_available: 'Náhľad nie je k dispozícii',
  no_preview_hint: 'Tento typ súboru sa nedá zobraziť v náhľade, ale aj tak sa odošle.',
  max_documents_reached: 'Naraz môžete priložiť najviac 10 dokumentov.',
  open_file: 'Stiahnuť súbor',
  twofa_title: 'Dvojfaktorové overenie',
  twofa_method_totp: 'Overovacia aplikácia',
  twofa_method_sms: 'SMS',
  twofa_method_email: 'E-mail',
  twofa_enter_app: 'Zadaj 6-miestny kód z overovacej aplikácie.',
  twofa_enter_sms: 'Zadaj 6-miestny kód, ktorý sme poslali SMS.',
  twofa_enter_email: 'Zadaj 6-miestny kód, ktorý sme poslali na e-mail.',
  twofa_resend: 'Poslať kód znova',
  twofa_try_another: 'Skúsiť inú metódu',
  twofa_remember_device: 'Na tomto zariadení sa 30 dní nepýtať',
  twofa_sent: 'Poslali sme kód.',
  twofa_invalid_code: 'Tento kód je nesprávny. Skús to znova.',
  twofa_something_wrong: 'Niečo sa pokazilo. Skús to znova.',
  twofa_method_unavailable: 'Táto metóda nie je k dispozícii.',
  twofa_on_desc: 'Dvojfaktorové overenie je zapnuté. Pri každom prihlásení budeš potrebovať kód.',
  twofa_off_desc: 'Pridaj po hesle druhý krok. Overovacie aplikácie sú najbezpečnejšie.',
  twofa_methods: 'Metódy',
  twofa_on: 'Zapnuté',
  twofa_add: 'Pridať',
  twofa_default_method: 'Predvolená metóda',
  twofa_default: 'Predvolené',
  twofa_turn_off: 'Vypnúť',
  twofa_disable_hint: 'Zadaj heslo a aktuálny kód na vypnutie dvojfaktorového overenia.',
  twofa_disable_need: 'Zadaj heslo a overovací kód.',
  twofa_code_placeholder: '6-miestny kód alebo záložný kód',
  twofa_send_code: 'Poslať kód',
  twofa_primary_updated: 'Predvolená metóda bola aktualizovaná.',
  twofa_disabled: 'Dvojfaktorové overenie je vypnuté.',
  twofa_enabled: 'Dvojfaktorové overenie je teraz zapnuté.',
  twofa_totp_help: 'Naskenuj tento QR kód v Google Authenticator, Authy alebo 1Password. Kľúč môžeš zadať aj ručne.',
  twofa_secret_copied: 'Kľúč skopírovaný',
  twofa_sms_help: 'Zadaj číslo v medzinárodnom formáte. Pošleme 6-miestny kód SMS.',
  twofa_email_help: 'Pošleme 6-miestny kód na e-mail tvojho účtu.',
  twofa_backup_title: 'Záložné kódy',
  twofa_backup_help: 'Ulož si tieto jednorazové kódy na bezpečné miesto. Každý kód možno použiť raz, keď stratíš telefón.',
  twofa_copy_codes: 'Kopírovať kódy',
  twofa_codes_copied: 'Záložné kódy skopírované',
  twofa_regenerate: 'Získať nové záložné kódy',
  twofa_regenerate_hint: 'Tým sa nahradia nepoužité záložné kódy. Zadaj heslo a aktuálny kód.',
  twofa_backup_remaining: 'Zostáva {n} nepoužitých záložných kódov',
  twofa_new_codes: 'Nové záložné kódy',
  twofa_sms_unavailable: 'SMS kódy zatiaľ nie sú k dispozícii.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "Priradené úlohy Kjuup sa skopírujú do projektu Kjuup vo vašom Todoist. Zmeny v Todoist sa nekopírujú späť.",
  todoist_connect: "Pripojiť Todoist",
  todoist_connected: "Todoist pripojený",
  todoist_connect_failed: "Pripojenie k Todoist zlyhalo",
  todoist_disconnect: "Odpojiť",
  todoist_disconnected: "Todoist odpojený",
  todoist_disconnect_confirm: "Odpojiť Todoist? Úlohy, ktoré už v Todoist sú, zostanú. Synchronizácia sa zastaví.",
  todoist_sync_now: "Synchronizovať",
  todoist_syncing: "Synchronizuje sa…",
  todoist_sync_done: "Synchronizácia dokončená",
  todoist_sync_failed: "Synchronizácia zlyhala",
  todoist_auth_error: "Znova pripojte Todoist, aby synchronizácia pokračovala.",
  todoist_last_sync: "Posledná synchronizácia",
  todoist_not_connected: "Todoist nie je pripojený",
  todoist_auth_url_failed: "Autorizačnú stránku Todoist sa nepodarilo otvoriť.",
  recommend_text: "Pridaj sa ku Kjuup, zostaň v spojení a maj svoju komunikáciu v poriadku. Spoj svoje kanály, drž správy v správnych projektoch a začínaj každé ráno súhrnom a svojimi úlohami – všetko synchronizované s aplikáciami, ktoré už používaš. Začni zadarmo:",
  pro_auth_signin_title: 'Vitajte späť',
  pro_auth_signin_sub: 'Prihláste sa pracovným e-mailom.',
  pro_auth_email_or_username: 'E-mail alebo používateľské meno',
  pro_auth_email_placeholder: 'meno@spolocnost.sk',
  pro_auth_forgot_password: 'Zabudli ste heslo?',
  pro_auth_create_account: 'Vytvoriť účet',
  pro_auth_show_password: 'Zobraziť heslo',
  pro_auth_hide_password: 'Skryť heslo',
  pro_auth_register_sub: 'Pošleme vám odkaz na potvrdenie vášho e-mailu.',
  pro_auth_register_plus_sub: 'Zvoľte si používateľské meno a heslo. Potom si nastavíte bezpečnostný PIN.',
  pro_auth_check_credentials: 'Skontrolujte svoj e-mail a heslo',
  pro_news_export_pdf: 'Exportovať ako PDF',
  pro_news_pdf_failed: 'PDF sa nepodarilo vytvoriť.',
  pro_news_pdf_attachments: 'Prílohy',
  pro_news_pdf_video: 'Video',
  pro_auth_forgot_sub: 'Zadajte svoj e-mail a pošleme vám odkaz na obnovenie hesla.',
  pro_auth_send_link: 'Poslať odkaz na obnovenie',
  pro_auth_plus_reset: 'Obnoviť pomocou PIN',
  pro_auth_show_pin: 'Zobraziť PIN',
  pro_auth_hide_pin: 'Skryť PIN',
  v2_auth_plus_only: 'Iba Kjuup+',
  room_action_media: "Súbory",
  room_tab_overview: "Prehľad",
  room_tab_history: "História",
  chat_info_media: "Súbory",
  messages: "správy",
  pro_todo_project_required: "Vyberte projekt",
  pro_todo_choose_project: "Pre ktorý projekt je táto úloha?",
  cockpit_report_delete_confirm: "Odstrániť tento denný report?",
  cockpit_report_deleted: "Denný report odstránený",
  cockpit_tab_company: "Firma",
  cockpit_bookmarked_priorities: "Označené úlohy",
  cockpit_load_error: "Cockpit sa nepodarilo načítať.",
  cockpit_retry: "Skúsiť znova",
  cockpit_yesterday: "Včera",
  cockpit_greeting_morning: "Dobré ráno",
  cockpit_greeting_day: "Dobrý deň",
  cockpit_greeting_evening: "Dobrý večer",
  cockpit_assistant_q_open: "Čo je dnes otvorené?",
  cockpit_assistant_q_summarize: "Zhrň chat {{room}}",
  cockpit_assistant_q_overdue: "Ktoré úlohy sú po termíne?",
  cockpit_assistant_new: "{{n}} nových",
  cockpit_assistant_important: "{{n}} dôležitých",
  cockpit_assistant_title: "Asistent Kjuup",
  cockpit_assistant_hint: "Ťuknite a opýtajte sa",
  room_overview_priority_no_detail: "Report neuvádza k tejto priorite ďalšie podrobnosti.",
  room_overview_priority_from: "Zdroj: {{name}}",
  room_overview_priority_open_task: "Otvoriť úlohu",
  cockpit_priority_position: "{{index}} z {{total}} priorít",
  room_overview_today_title: "Dnes dôležité",
  room_overview_all_tasks: "Všetky",
  room_overview_tasks_empty: "Žiadne otvorené termíny ani úlohy",
  room_overview_appointments_empty: "Žiadne nadchádzajúce stretnutia",
  room_overview_no_priorities: "V poslednom reporte nie sú žiadne otvorené priority.",
  cockpit_report_top5: "Top 5 priorít",
  cockpit_report_todo_created: "Úloha vytvorená",
  cockpit_report_source_missing: "Zdrojová správa sa nenašla.",
  delete_bookmarked_priority_confirm: "Naozaj chcete odstrániť túto označenú úlohu?",
  cockpit_report_create_todo: "Vytvoriť úlohu",
  cockpit_priorities_deleting: "Odstraňovanie …",
  cockpit_priorities_select: "Odstrániť viaceré",
  cockpit_report_none: "Žiadne záznamy.",
  cockpit_priorities_delete_confirm: "Naozaj chcete odstrániť označené úlohy ({count})?",
  cockpit_priorities_delete_failed: "Nepodarilo sa odstrániť úlohy: {count}",
  cockpit_priorities_deleted: "Odstránené úlohy: {count}",
  cockpit_priorities_selected: "Vybraté: {count}",
  cockpit_channel_connected: "Pripojené",
  cockpit_channel_not_connected: "Nepripojené",
  cockpit_channel_connect: "Pripojiť",
  cockpit_channel_chat: "Chat Kjuup",
  cockpit_channel_active: "Aktívne",
  cockpit_channel_hidden: "Skryté",
  cockpit_channel_enable: "Zapnúť",
  cockpit_channel_email: "E-mail",
  cockpit_channel_check: "Skontrolovať pripojenie",
  cockpit_channel_fix: "Skontrolovať",
  cockpit_channel_forward: "Adresa na preposielanie",
  cockpit_channel_not_set_up: "Nenastavené",
  cockpit_channel_set_up: "Nastaviť",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "Pripojenie prerušené",
  cockpit_channel_importing: "Prebieha import",
  cockpit_channel_removing: "Odpájanie",
  cockpit_channel_reconnect: "Pripojiť znova",
  cockpit_channels_title: "Kanály",
  cockpit_company_role_super_admin: "Správca firmy",
  cockpit_company_role_dept_admin: "Správca oddelenia",
  cockpit_company_role_member: "Zamestnanec",
  cockpit_company_none: "Nenašla sa žiadna firma Kjuup+",
  cockpit_company_eyebrow: "Firma",
  cockpit_company_inactive: "neaktívna",
  cockpit_company_settings: "Nastavenia firmy",
  cockpit_company_employees: "Zamestnanci",
  cockpit_company_internal_rooms: "Interné projekty",
  cockpit_report_all_projects: "Všetky projekty",
  cockpit_report_progress_emails: "Analyzujú sa e-maily",
  cockpit_report_progress_chats: "Analyzujú sa správy chatu",
  cockpit_report_progress_documents: "Analyzujú sa prílohy a dokumenty",
  cockpit_report_progress_tasks: "Analyzujú sa úlohy",
  cockpit_report_progress_summarizing: "Analyzuje sa obsah",
  cockpit_report_progress_reading: "Preberá sa už analyzovaný obsah",
  cockpit_report_progress_collecting: "Zbierajú sa e-maily, chaty a úlohy z vašich projektov",
  cockpit_report_progress_priorities: "Zostavujú sa priority, termíny a rozhodnutia",
  cockpit_report_progress_queued: "Report sa pripravuje",
  cockpit_report_creating_title: "Váš denný report sa vytvára",
  cockpit_report_progress_count_one: "Analyzovaná 1 položka",
  cockpit_report_progress_count_many: "Analyzované položky: {{count}}",
  cockpit_report_progress_hint: "Zvyčajne to trvá jednu až dve minúty – medzitým môžete cockpit ďalej používať.",
  cockpit_report_time_hint: "Denný report sa vytvára každý deň o {{hour}}:00 pre päť najaktívnejších projektov.",
  room_overview_priorities_title: "Aktuálny stav a priority",
  room_overview_as_of: "Stav k: {{time}}",
  cockpit_report_delete: "Odstrániť denný report",
  cockpit_report_unread: "Nové",
  cockpit_report_clear_project: "Zobraziť všetky projekty",
  cockpit_filter_project: "Projekt",
  cockpit_filter_all_projects: "Všetky projekty",
  cockpit_report_recreate: "Vytvoriť denný report znova",
  cockpit_report_hide_previous: "Skryť predchádzajúce denné reporty",
  cockpit_report_show_previous: "Zobraziť predchádzajúce denné reporty",
  cockpit_report_room_empty: "Pre tento projekt zatiaľ nie je žiadny denný report",
  cockpit_report_empty: "Zatiaľ žiadny denný report",
  cockpit_report_room_empty_hint: "Vytvorte denný report iba pre tento projekt.",
  cockpit_report_needs_mailbox: "Pripojte e-mailový účet, aby Kjuup mohol vytvárať denný report s automatickými úlohami.",
  cockpit_report_create: "Vytvoriť denný report",
  cockpit_email_connect: "Pripojiť e-mail",
  cockpit_email_none_title: "Zatiaľ nie je pripojený žiadny e-mailový účet",
  cockpit_email_none_reports: "Pripojte svoju schránku, aby Kjuup priraďoval prichádzajúce e-maily k vašim projektom a vytváral z nich denné reporty s úlohami.",
  cockpit_email_none_client: "Pripojte Gmail, Outlook alebo IMAP a čítajte, priraďujte a odpovedajte na e-maily priamo v Kjuup.io.",
  cockpit_email_reports_title: "Doterajší e-mailový klient",
  cockpit_email_reports_text: "Žiadna schránka v Kjuup.io · projekty s denným reportom o {{hour}}:00: {{rooms}} · prichádzajúce e-maily sa priraďujú k vašim projektom.",
  cockpit_email_reports_rooms: "Spravovať projekty",
  cockpit_email_settings: "Nastavenia e-mailu",
  cockpit_email_error_title: "Skontrolovať pripojenie",
  cockpit_email_client_title: "Príjem nastavený",
  cockpit_email_accounts_n: "Pripojené účty: {{n}}",
  cockpit_email_last_sync: "posledné stiahnutie {{when}}",
  cockpit_email_report_at: "Denný report o {{hour}}:00",
  cockpit_email_open_inbox: "Otvoriť schránku",
  cockpit_email_eyebrow: "Kjuup-Email",
  cockpit_email_accounts_label: "Pripojené e-mailové adresy",
  cockpit_email_detail_loading: "Načítava sa e-mail …",
  cockpit_email_detail_failed: "E-mail sa nepodarilo načítať.",
  cockpit_email_detail_empty: "Tento e-mail neobsahuje text.",
  cockpit_personal_settings: "Osobné nastavenia",
  cockpit_companies: "Firmy",
  cockpit_title: "Cockpit",
  cockpit_back: "Späť na prehľad",
  cockpit_day_overview: "Váš deň v kocke",
  email_delete_email_failed: "E-mail sa nepodarilo odstrániť.",
  cockpit_email_deleted: "E-mail odstránený",
  cockpit_email_sent_empty: "Zatiaľ žiadne odoslané e-maily.",
  cockpit_email_incoming_empty: "Zatiaľ žiadne prichádzajúce e-maily.",
  cockpit_email_incoming_title: "E-maily",
  cockpit_email_incoming_sub: "Priraďte prichádzajúce a odoslané e-maily k svojim projektom. Priradenie tu môžete upraviť.",
  cockpit_email_incoming_unassigned_n: "Nepriradené: {{n}}",
  cockpit_email_folder_inbox: "Doručené",
  cockpit_email_folder_sent: "Odoslané",
  cockpit_email_open: "Otvoriť e-mail",
  cockpit_email_incoming_suggested: "Návrh: {{room}}",
  cockpit_email_incoming_apply: "Použiť",
  cockpit_email_incoming_adjust: "Upraviť priradenie",
  cockpit_email_incoming_saving: "Ukladanie …",
  cockpit_email_incoming_unassigned: "Nepriradené",
  cockpit_email_incoming_show_less: "Zobraziť menej",
  cockpit_email_incoming_show_all: "Zobraziť všetko ({{n}})",
  cockpit_io_settings: "Nastavenia Kjuup.io",
  cockpit_io_settings_sub: "Tarifa a licencie, priradenie zamestnancov, ako aj fakturácia a faktúry.",
  products_coming_soon: "Čoskoro",
  cockpit_upsell_io_title: "Vaša kancelária, ktorá myslí s vami",
  cockpit_upsell_io_text: "Prepojte svoje e-mailové účty s Kjuup. E-maily, prílohy a správy sa automaticky ukladajú do zodpovedajúceho projektu a voliteľne ich možno ukladať na váš server. Každý deň dostanete súhrn všetkých projektov s najdôležitejšími bodmi zo všetkých obsahov a vaše úlohy sa synchronizujú s kalendárom alebo aplikáciou na úlohy.",
  cockpit_upsell_io_soon_title: "Zatiaľ nie je možné objednať",
  cockpit_upsell_io_soon_text: "Kjuup.io čoskoro štartuje. Vyžiadajte si informácie – ozveme sa vám, keď si budete môcť Kjuup.io objednať.",
  cockpit_upsell_io_planned_price: "Plánovaná cena",
  cockpit_upsell_io_cta_request: "Vyžiadať informácie",
  kjuup_plus_abo_per_year: "/ rok",
  kjuup_plus_abo_per_month: "/ mesiac",
  kjuup_plus_abo_status_active: "Aktívne",
  kjuup_plus_abo_status_requested: "Žiadosť o zrušenie",
  kjuup_plus_abo_status_past_due: "Platba čaká",
  kjuup_plus_abo_eyebrow: "Kjuup+ · Predplatné",
  kjuup_plus_abo_title: "Balík Kjuup+",
  kjuup_plus_abo_seats_free_one: "Zostáva 1 miesto",
  kjuup_plus_abo_billing: "Spôsob platby",
  kjuup_plus_abo_yearly: "Ročne",
  kjuup_plus_abo_monthly: "Mesačne",
  kjuup_plus_abo_amount: "Suma",
  kjuup_plus_abo_ends: "Končí dňa",
  kjuup_plus_abo_renews: "Ďalšie predĺženie",
  kjuup_plus_abo_next_invoice: "Ďalšia faktúra",
  kjuup_plus_abo_intro: "Úvodná cena",
  kjuup_plus_abo_pending_tier: "Od ďalšieho predĺženia",
  kjuup_plus_abo_manual: "Kjuup+ je pre vašu firmu aktívne na základe individuálnej dohody.",
  kjuup_plus_abo_invoices: "Faktúry",
  kjuup_plus_abo_invoice_paid: "Zaplatené",
  kjuup_plus_abo_invoice_view: "Zobraziť",
  kjuup_plus_abo_invoices_less: "Zobraziť menej",
  kjuup_plus_abo_member_hint: "Fakturáciu a zrušenie spravujú správcovia firmy.",
  kjuup_plus_abo_withdraw: "Stiahnuť žiadosť",
  kjuup_plus_abo_cancel_note: "Dôvod (voliteľné)",
  kjuup_plus_abo_cancel_send: "Požiadať o zrušenie",
  kjuup_plus_abo_cancel: "Zrušiť predplatné",
  cockpit_upsell_plus_f1: "Správa komunikačných aktivít všetkých zamestnancov",
  cockpit_upsell_plus_f2: "Informovanie vybraných skupín používateľov vo firme",
  cockpit_upsell_plus_f3: "Ukladanie interných skupinových chatov",
  cockpit_upsell_plus_when_yearly: "pri ročnej platbe",
  cockpit_upsell_plus_size_small: "1–50 zamestnancov",
  cockpit_upsell_plus_size_large: "51–200 zamestnancov",
  cockpit_upsell_plus_title: "Kjuup+ pre firmy",
  cockpit_upsell_plus_text: "Spravujte zamestnancov, práva na písanie a firemnú komunikáciu na jednom mieste. Interné kanály zostávajú u vašich zamestnancov, externé kanály vás spájajú s projektovými partnermi a vybrané skupiny môžete informovať cielene. Okrem Kjuup+ si môžete objednať prístupy Kjuup.io pre skupiny zamestnancov. Kjuup+ a Kjuup.io je možné kombinovať.",
  cockpit_upsell_plus_size: "Veľkosť firmy",
  cockpit_upsell_plus_billing: "Spôsob platby",
  cockpit_upsell_plus_per_company: "/ firma · mesiac bez DPH",
  cockpit_upsell_plus_onboarding: "Náklady na zavedenie závisia od veľkosti firmy",
  cockpit_upsell_plus_larger: "Ceny pre väčšie firmy na požiadanie",
  cockpit_upsell_plus_cta: "Nezáväzne dopytovať",
  cockpit_kpi_deadlines_tasks: "Termíny a úlohy",
  cockpit_kpi_appointments: "Stretnutia",
  cockpit_room_admin: "Správa projektov a chatov",
  cockpit_room_admin_sub: "Všetky projekty firmy s členmi, médiami a chatmi.",
  pro_todo_not_found: "Táto úloha už nie je dostupná.",
  cockpit_chip_overdue: "Po termíne",
  cockpit_chip_today: "Dnes",
  cockpit_calendar_week: "{{week}}. týždeň",
  cockpit_prev_week: "Predchádzajúci týždeň",
  cockpit_next_week: "Ďalší týždeň",
  cockpit_chip_requested: "Vyžiadané",
  cockpit_todo_due: "Termín {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "od {{name}}",
  cockpit_todo_since: "od {{when}}",
  cockpit_todo_no_date: "Bez dátumu",
  cockpit_todo_mark_done: "Označiť ako hotové",
  cockpit_my_tasks_title: "Moje úlohy",
  cockpit_today_tasks_group: "Úlohy na dnes",
  cockpit_assign_none: "Nikto nie je priradený",
  no_project_found: "Projekt sa nenašiel",
  cockpit_row_more_actions: "Ďalšie akcie",
  cockpit_assign_proposal: "Rozpoznané {{name}} – priradiť?",
  cockpit_assign_proposal_confirm: "Priradiť",
  cockpit_assign_proposal_dismiss: "Ignorovať",
  cockpit_priority_date: "Dátum",
  todo_calendar_add: "Pridať do kalendára",
  todo_calendar_remove: "Odstrániť z kalendára",
  cockpit_todo_change_project: "Zmeniť projekt",
  cockpit_todo_set_date: "Nastaviť dátum",
  pro_todo_done_confirm: "Naozaj chcete túto úlohu označiť ako hotovú?",
  cockpit_task_delete_failed: "Úlohu sa nepodarilo odstrániť.",
  cockpit_setup_title: "Dokončiť nastavenie",
  cockpit_setup_text: "Rozhodnite sa, či chcete používať chaty a či má Kjuup.io fungovať ako e-mailový klient, alebo len s projektmi a dennými reportmi.",
  cockpit_setup_cta: "Nastaviť teraz",
  cockpit_group_tasks: "Termíny a úlohy",
  cockpit_group_appointments: "Stretnutia",
  cockpit_report_no_activity: "V tomto projekte nebolo za posledných 24 hodín žiadne nové správy ani e-maily.",
  cockpit_report_room_unavailable: "Tento projekt nie je dostupný.",
  cockpit_report_create_failed: "Denný report sa nepodarilo vytvoriť.",
  cockpit_report_created: "Denný report vytvorený",
  addon_enable_confirm: "Zapnúť doplnok?",
  addon_enable: "Zapnúť",
  addon_enabled: "Doplnok zapnutý",
  nav_email: "E-mail",
  nav_my_cockpit: "Môj cockpit",
  nav_news: "Novinky",
  nav_recommend: "Odporučiť",
  pro_todo_status_done: "Hotovo",
  pro_todo_status_open: "Otvorené",
  v2_todo_remove: "Odstrániť",
  pro_todo_search_people: "Hľadať osoby",
  pro_todo_clear: "Vymazať",
  pro_todo_assigned: "(priradené)",
  pro_todo_no_people: "Nenašli sa žiadne osoby",
  pro_todo_search_rooms: "Hľadať projekty",
  pro_todo_no_rooms_match: "Žiadne projekty pre „{{q}}“",
  pro_todo_no_rooms: "Nenašli sa žiadne projekty",
  pro_todo_activity: "Aktivita",
  pro_todo_show_less: "Zobraziť menej",
  pro_todo_show_all: "Zobraziť všetko ({{n}})",
  pro_todo_due: "Termín",
  pro_todo_room: "Projekt",
  pro_todo_select_room: "Vybrať projekt",
  pro_todo_status: "Stav",
  pro_todo_more: "Viac",
  pro_todo_edit_title: "Upraviť úlohu",
  pro_todo_description: "Popis",
  pro_todo_created_by: "Vytvoril(a)",
  pro_todo_chat: "Chat",
  navigate_to_source: "Prejsť na zdroj",
  todo_calendar_connect_title: "Nie je pripojený žiadny kalendár",
  todo_calendar_connect_body_web: "Pripojte kalendár v nastaveniach synchronizácie kalendára, aby ste don mohli pridávať úlohy.",
  todo_calendar_connect: "Pripojiť",
  todo_calendar_removed: "Odstránené z vášho kalendára",
  todo_calendar_added_later: "Pridané. Kalendár nebol dostupný, Kjuup to skúsi znova neskôr.",
  todo_calendar_added: "Pridané do vášho kalendára",
  todo_calendar_no_date: "Do kalendára možno pridať iba úlohu s dátumom.",
  todo_calendar_failed: "Kalendár sa nepodarilo aktualizovať. Skúste to prosím znova.",
  todo_calendar_date_title: "Zatiaľ bez dátumu",
  todo_calendar_date_save: "Nastaviť dátum a pridať",
  todo_calendar_date_body_web: "Táto označená úloha zatiaľ nemá dátum. Nastavte ho, aby ste ju mohli pridať do kalendára.",
  kjuup_io_setup_saved: "Nastavenie uložené",
  kjuup_io_setup_step: "Krok",
  kjuup_io_setup_chats_title: "Chcete používať chaty?",
  kjuup_io_setup_email_title: "Kde chcete čítať svoje e-maily?",
  kjuup_io_setup_chats_sub: "Chaty s kolegami a projektovými partnermi sú voliteľné. V cockpite ich môžete kedykoľvek zobraziť alebo skryť.",
  kjuup_io_setup_email_sub: "Tu len určujete, či používate e-mailového klienta v Kjuup, alebo naďalej pracujete so svojím doterajším programom, napríklad Outlookom či iným. Neskôr to môžete zmeniť.",
  kjuup_io_setup_chats_yes: "Áno, zobraziť chaty",
  kjuup_io_setup_chats_yes_text: "Správy obsahujú chaty a e-maily. Projekty majú skupinové chaty pre všetkých zúčastnených.",
  kjuup_io_setup_chats_no: "Nie, pracovať bez chatov",
  kjuup_io_setup_chats_no_text: "Chaty sú skryté. Zo „Správ“ sa stane „E-mail“; projekty, úlohy a denné reporty zostávajú.",
  kjuup_io_setup_email_client: "E-mailový klient v Kjuup",
  kjuup_io_setup_email_client_text: "Čítajte e-maily a odpovedajte na ne priamo v Kjuup.",
  kjuup_io_setup_email_reports: "Doterajší e-mailový klient",
  kjuup_io_setup_email_reports_text: "Naďalej čítajte e-maily a odpovedajte na ne vo svojom súčasnom programe, napríklad v Outlooku či inom.",
  kjuup_io_setup_skip: "Neskôr",
  next: "Ďalej",
  kjuup_io_setup_finish: "Dokončiť nastavenie",
  today_label: "dnes",
  tomorrow_label: "zajtra",
  cockpit_todo_overdue: "po termíne",
  cockpit_report_management_fazit: "Zhrnutie pre vedenie",
  cockpit_todo_appointment: "Stretnutie",
  cockpit_todo_deadline: "Termín",
  cockpit_todo_deadline_define: "Určiť termín",
  pro_todo_status_acknowledged: "Potvrdené",
  pro_todo_responsible: "Zodpovedná osoba",
  pro_todo_notice_confirmed: "Potvrdené v chate",
  pro_todo_notice_sent_at: "Správa odoslaná",
  pro_todo_notice_again: "Odoslať správu znova",
  pro_todo_notice_send: "Informovať správou Kjuup",
  pro_todo_add_assignee: "Pridať",
  pro_todo_edit: "Upraviť",
  pro_todo_change_room: "Zmeniť projekt",
  pro_todo_due_on: "Termín do",
  pro_todo_edit_due: "Upraviť termín",
  pro_todo_no_date: "Bez dátumu",
  pro_todo_edit_description: "Upraviť popis",
  pro_todo_no_description: "Zatiaľ bez popisu",
  pro_todo_title_label: "Názov",
  pro_todo_title_placeholder: "Zadajte názov...",
  pro_todo_task: "Úloha",
  pro_todo_what: "Čo treba urobiť?",
  pro_todo_source_email: "E-mail",
  pro_todo_sources: "Zdroje",
  previous: "Predchádzajúce",
  kjuup_plus_abo_tier_large: "Kjuup+ Large (do {max} zamestnancov)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small (do {max} zamestnancov)",
  kjuup_plus_abo_status_ends: "Končí {date}",
  kjuup_plus_abo_seats_over: "Viac ako {max} zamestnancov – Kjuup vás bude kontaktovať s individuálnou ponukou.",
  kjuup_plus_abo_seats_next: "Ak pribudnú ďalší zamestnanci, balík sa automaticky prepne na {next} (pomerne vyúčtované).",
  kjuup_plus_abo_seats_used: "Obsadené {used} z {total} miest",
  kjuup_plus_abo_seats_free: "Voľné miesta: {count}",
  kjuup_plus_abo_intro_until: "do {date}",
  kjuup_plus_abo_invoice_open: "Neuhradené · splatnosť {date}",
  kjuup_plus_abo_invoices_all: "Zobraziť všetky ({count})",
  kjuup_plus_abo_requested_hint: "Zrušenie požadované {date}. Kjuup ho potvrdí ku koncu obdobia ({end}).",
  kjuup_plus_abo_cancel_hint: "Kjuup posúdi vašu žiadosť a potvrdí zrušenie ku koncu obdobia ({end}). Dovtedy zostáva Kjuup+ aktívne.",
  kjuup_plus_abo_withdrawn: "Žiadosť o zrušenie stiahnutá",
  kjuup_plus_abo_requested: "Zrušenie požadované",
  cockpit_upsell_plus_intro_hint: "prvé {months} mesiace, potom {price}",
  cockpit_upsell_plus_badge: "ZAVÁDZACIA CENA NA {months} MESIACE",
  calendar_syncing: "Aktualizácia z kalendára…",
  calendar_sync_up_to_date: "Kalendár je aktuálny",
  calendar_sync_failed: "Synchronizácia zlyhala",
  todo_created_from_message: "Úloha vytvorená z tejto správy",
  kjuup_io_todo_calendar_trial_ended_note: "Synchronizácia kalendára · Predplatiť",
  kjuup_io_todo_calendar_nudge: "Synchronizovať toto ToDo do kalendára?",
  kjuup_io_todo_calendar_nudge_cta: "Aktivovať Kjuup.io",
  todo_confirmed: "Úloha potvrdená",
  pro_todo_bulk_delete_title: "Odstrániť úlohy ({{n}})?",
  pro_todo_previous_none_own: "Úlohy po termíne vám pridelili iní a odstrániť ich môžu iba oni.",
  pro_todo_previous_none: "Žiadne úlohy po termíne",
  pro_todo_previous_title: "Odstrániť úlohy po termíne ({{n}})?",
  pro_todo_previous_text: "Všetky vaše otvorené úlohy z predchádzajúcich dní budú odstránené.",
  pro_todo_previous_skipped: "Úlohy pridelené inými zostanú: {{n}}.",
  unassign_task_confirm: "Chcete zrušiť svoje priradenie k tejto úlohe?",
  pro_todo_delete_title: "Odstrániť úlohu",
  pro_todo_today: "Dnes",
  pro_todo_yesterday: "Včera",
  pro_todo_since_yesterday: "Od včera",
  pro_todo_mark_open: "Označiť ako otvorenú",
  pro_todo_of_completed: "Dokončené {{done}} z {{total}}",
  pro_todo_pick_date: "Vyberte dátum",
  pro_todo_show_day: "Zobraziť deň",
  pro_todo_section_upcoming: "Nadchádzajúce",
  pro_todo_section_done: "Hotovo",
  pro_todo_room_empty_today: "Dnes v tomto projekte nie sú žiadne úlohy",
  pro_todo_room_empty_day: "V tento deň v tomto projekte nie sú žiadne úlohy",
  pro_todo_delete_previous: "Odstrániť všetky",
  pro_todo_empty_title: "Nič tu nie je",
  pro_todo_empty_hint: "Tomuto zobrazeniu nezodpovedajú žiadne úlohy.",
  pro_todo_selected: "Vybrané: {{n}}",
  pro_todo_adjust_done: "Hotovo",
  pro_todo_deleting: "Odstraňuje sa...",
  pro_todo_reopen: "Znovu otvoriť úlohu",
  pro_todo_step_done: "Hotovo",
  pro_todo_mark_not_started: "Označiť ako nezačaté",
  pro_todo_mark_in_progress: "Označiť ako prebiehajúce",
  pro_todo_open_room: "Otvoriť projekt",
  pro_todo_new_task: "Nová úloha",
  select_user_back_to_in_progress: "Vyberte používateľa na presun späť do stavu Prebieha",
  cockpit_email_accounts_n_many: "Pripojené účty: {{n}}",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Kontakty Kjuup",
  combined_tab_teams: "Kontakty Teams",
  combined_bridge_failed: "Kópiu v Teams sa nepodarilo vytvoriť.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Kontakty Kjuup a Teams: vytvorí sa nová skupina, ktorá sa zobrazí aj v Microsoft Teams.",
  teams_new_chat_title: "Nový chat Teams",
  teams_new_chat_topic: "Názov skupiny (nepovinné)",
  teams_new_chat_start: "Začať chat",
  teams_new_chat_creating: "Vytvára sa chat…",
  teams_new_chat_forbidden: "Microsoft Teams tento chat nepovoľuje (napr. osoba mimo vašej organizácie alebo pravidlo vášho IT).",
  teams_new_chat_too_many: "Príliš veľa osôb na jeden chat.",
  teams_new_chat_type_hint: "Zadajte meno na vyhľadávanie vo vašej organizácii.",
  teams_new_chat_directory_forbidden: "Vaša organizácia nepovoľuje vyhľadávanie v adresári. Zobrazujú sa len osoby z vašich chatov Teams.",
  teams_new_chat_account: "Účet",
};
